window.languages = window.languages || {};
var ko = {
    "STATIC": {
        "SHARE_WITH": "...와 공유하기",
        "WIDGET_TITLE": "위젯 제목",
        "REPORT_COMMENTS": "보고서 커멘트",
        "MODAL_HEADERS": {
            "WIDGET_CONFIG": "위젯 설정",
            "SHARE_REPORT": "보안익명액세스를 위한 보고서 공유",
            "CHANGE_PASSWORD": "@:STATIC.TOPBAR_HEADERS.CHANGE_PASSWORD"
        },
        "CAMPAIGN": "캠페인",
        "LINK_URL": "링크 URL",
        "SHOW_CHART_TOP_ROWS1": "챠트의 상단을 표시하기",
        "SHOW_CHART_TOP_ROWS5": "상단",
        "GOAL_METRICS": "목표 메트릭스",
        "BUTTONS": {
            "ADD_NEW_DIMENSIONS": "새로운 디멘션 추가",
            "GOAL_REPORT_TAB": "목표",
            "NEW_GOAL": "새로운 목표",
            "EXPORT": "추출",
            "NEW_CUSTOM_EVENT": "새로운 커스텀 이벤트",
            "NEXT": "다음",
            "BACK": "뒤로",
            "REPORT_ON_ONE_PERIOD": "한 기간의 리포트",
            "PRESS_GENERATE": "생성버튼을 누르세요",
            "IMAGE": "이미지",
            "SHARE": "보고서 공유",
            "CUSTOM": "커스텀",
            "DEACTIVATE_TWO_FACTOR_AUTH": "2단계 인증을 무효화",
            "IMAGE_AND_TEXT": "이미지와 문자",
            "CREATE_GOAL": "새로운 목표설정",
            "APPLY": "적용",
            "HIDE_LEGEND": "설명문 감추기",
            "DATEPICKER": {
                "LAST_30_DAYS": "지난 30일",
                "TO": "까지",
                "FROM": "부터",
                "LAST_MONTH": "지난 달",
                "LAST_7_DAYS": "지난 7일",
                "THIS_MONTH": "이번 달",
                "THIS_QUARTER": "이번 분기",
                "YESTERDAY": "어제",
                "TODAY": "오늘"
            },
            "SAVE_AND_ADD_ANOTHER": "저장 및 다른것 추가",
            "NEW_CUSTOM_DIMENSION": "새로운 커스텀 디멘션",
            "UPDATE": "업데이트",
            "REGULAR_REPORT_TAB": "정기적",
            "SHOW_LEGEND": "설명문 표시",
            "CANCEL": "취소",
            "GENERATE": "생성",
            "COMPARE_TWO_PERIODS": "두 기간 비교하기",
            "RUN": "실행",
            "EDIT": "수정",
            "EXPORT_CSV": "테이블을 CSV로 저장",
            "EXPORT_JSON": "테이블을 JSON으로 저장",
            "SETUP_TWO_FACTOR_AUTH": "2단계 인증 설정",
            "SAVE": "저장",
            "DELETE": "삭제",
            "BOOKMARK": "북마크",
            "SHOW_CHART": "차트 표시",
            "HIDE_CHART": "차트 숨기기",
            "FINISH": "완료",
            "TOGGLE": {
                "NO": "아니요",
                "YES": "예"
            }
        },
        "CUSTOM_DIMENSIONS": "커스텀 디멘션",
        "DATE": "날짜",
        "TOPBAR_HEADERS": {
            "LOGOUT": "로그아웃",
            "TWO_FACTOR_AUTH": "2단계 인증",
            "HELP_CENTER": "도움센터",
            "CHANGE_PASSWORD": "비밀번호 변경",
            "ACCOUNT_PLAN": "계정 플랜"
        },
        "REPORT_NAME": "보고서 이름",
        "CUSTOM_EVENTS": "커스텀 이벤트",
        "CONTENT": "콘텐츠",
        "DIMENSIONS": "디멘션",
        "TOOLTIPS": {
            "MARK_FAVOURITE_APP": "즐겨찾기에 추가"
        },
        "PAGE_HEADERS": {
            "TWO_FACTOR_AUTH": "@:STATIC.TOPBAR_HEADERS.TWO_FACTOR_AUTH",
            "TEAM_MEMBERS": "팀 멤버",
            "NEW_ALERT": "새로운 알림 생성",
            "DATA_SOURCES": "유입경로",
            "GOAL_MANAGEMENT": "목표 관리",
            "ALERTS": "알림",
            "NEW_GOAL": "새로운 목표 생성",
            "DUPLICATE_GOAL": "새로운 목표 생성",
            "REPORTS": "리포트",
            "CREATIVES": "크리에이티브",
            "APPS_CONFIGURATION": "앱 설정",
            "CUSTOM_DIMENSIONS": "@:STATIC.CUSTOM_DIMENSIONS",
            "TWO_FACTOR_AUTH_CONFIG": "2단계 인증 설정",
            "DASHBOARD": "대시보드",
            "EDIT_GOAL": "목표 수정",
            "CUSTOM_EVENTS": "커스텀 이벤트",
            "EDIT_ALERT": "알림 수정",
            "PARTNER_CONFIGURATION": "파트너 구성",
        },
        "SOURCE": "경로",
        "APP": "앱",
        "AGENCY": "대행사",
        "COHORT_METRICS": "코호트 메트릭스",
        "MISSING_DASHBOARD_DATA": "선택한 메트릭스의 데이터가 없습니다",
        "GOAL_FORECAST": "목표 예측",
        "TIME_BREAKDOWN": "기간 내역",
        "METRICS": "메트릭스",
        "DAU_METRICS": "User Activity Metrics",
        "PLATFORM": "플랫폼",
        "LINK_EXPIRATION_IN_DAYS": "링크의 유효기간",
        "SHOW_CHART_TOP_ROWS2": "테이블 열",
        "FILTERS": "필터",
        "SOURCE_METRICS": "소스 메트릭스",
        "SHARE_URL_DISCLAIMER1": "이 URL은 비공개입니다. 액세스 할 경우 누구든지 해당 링크로 접속할 수 있게 됩니다!",
        "COHORT_PERIODS": "코호트 기간",
        "PLACEHOLDERS": {
            "SELECT_OS": "OS 선택",
            "SELECT_EMAIL_ADDRESS": "이메일 주소 입력",
            "SELECT_EVENT": "이벤트 선택",
            "NEW_PASSWORD": "새 비밀번호",
            "SELECT_APP": "앱 선택",
            "ENTER_2FA_CODE": "코드",
            "SELECT_CAMPAIGN": "캠페인 선택",
            "SELECT_FILTER": "필터 선택",
            "SELECT_SOURCE": "경로 선택",
            "SELECT_PLATFORM": "플랫폼 선택",
            "CURRENT_PASSWORD": "현재 비밀번호"
        },
        "POPOVERS": {
            "PARTNER_CONFIG_STATUS": {
                "EXPORT": "상세한 포스트백 로그 추출",
                "TIMESPAN": "{{pull_since}}부터 {{pull_from}} ({{timezone}})까지의 데이터 기반입니다",
                "NO_DATA": "데이터가 없습니다",
                "STATUS_TYPE_STATISTICS": "<span>{{type}}</span>: {{ value }} ({{ percentage }}%)",
                "TYPE_SUCCESS": "성공",
                "TYPE_FAILURE": "실패",
                "TYPE_RETRIES": "재시도"
            },
            "FIRST_APP_ADDED": {
                "CONGRATS": "1단계 완료! 계속 진행하세요...",
                "MESSAGE": "다음 단계: Singular SDK를 귀하의 앱에 삽입하세요. \n아직 준비되지 않으셨다면 데이터 커넥터부터 추가하셔도 됩니다",
                "BUTTON": "SDK 연동",
                "ALTERNATIVE_BUTTON": "데이터 커넥터 추가하기"
            },
            "ADD_MORE_PLATFORM": {
                "CONGRATS": "좋은 시작입니다!...",
                "MESSAGE": "첫 번째 앱이 성공적으로 추가되었습니다. \n다른 OS(예: iOS, 안드로이드, 웹 등) 버전이 있나요?",
                "ADD_ANOTHER_PLATFORM_BUTTON": "다른 플랫폼 추가하기",
                "ONLY_ONE_PLATFORM_BUTTON": "플랫폼이 하나만 있음"
            },
        },
        "OS": "OS",
        "PAGES": {
            "TWO_FACTOR_AUTH": {
                "P2": "귀사의 싱귤러 계정의 보안을 한단계 더 강화하기 위해서 로그인 비빌번호 외에 두번째 인증코드를 추가하여 주시기 바랍니다. 설정이 완료되면 휴대폰에서 비밀번호와 인증코드를 모두 입력해야만 싱귤러 계정에 로그인 할 수 있습니다.",
                "P3": "<strong> Note: </strong> 2 단계 인증을 활성화하면 다른 모든 세션 (다른 장치 포함)에서 로그 아웃됩니다.",
                "P1": "현재의 계정에서는 2단계 인증이 <strong>비활성</strong>화 되어 있습니다.",
                "P1_ACTIVE": "현재의 계정에서는 2단계 인증이 <strong>활성</strong>화 되어 있습니다."
            },
            "SKADNETWORK": {
                "SKAN_PLUS_CHIP_TOOLTIP": {
                    "OPTIMIZED_MODEL": 'SKAN 모델 추천 적용',
                    "UNOPTIMIZED_MODEL": 'SKAN 모델 추천 가능'
                },
            },
            "TEAM_MEMBERS": {
                "INVITE": "새 회원 초대",
                "INVITE_MODAL": {
                    "WARN1": "보안 규정을 준수하기 위해 오직 개별 이메일로만 초대합니다.  (공통적으로 사용하는 이메일은 사용하지 금해주시기 바랍니다)",
                    "FIRST_NAME": "이름",
                    "LAST_NAME": "성",
                    "SEND_INVITE": "초대하기",
                    "WARN2": "초대된 사용자의 계정으로 모든 데이터에 엑세스 할 수 있으니 주의하여 주시기 바랍니다. 초대하기",
                    "INVITE_FULL_MEMBER": "정회원 초대하기",
                    "ATTENTION": "주의",
                    "EMAIL": "이메일 주소",
                },
                "AUTO_ADD_FUTURE_ITEMS": {
                    "TITLE": "새로운 ${itemType}이(가) 추가되면 자동으로 권한 부여",
                    "DESCRIPTION": {
                        "SDK_EVENTS_AGENCIES": "이 대행사는 시스템에 추가된 모든 새 SDK 이벤트에 액세스할 수 있습니다."
                    }
                },
                "MANAGE_PERMISSIONS_PAGE": {
                    "TITLE": {
                        "SDK_EVENTS": "SDK 이벤트 (${count}/${total})"
                    },
                    "DESCRIPTION": {
                        "SDK_EVENTS": "대행사가 파트너 포스트백에서 구성할 수 있는 SDK 이벤트를 선택하세요."
                    },
                    "NO_SDK_EVENTS_TEAM_USERS": "아직 수신된 SDK 이벤트가 없습니다.",
                    "NO_SDK_EVENTS_AGENCIES": "사용 가능한 SDK 이벤트가 없습니다. 아직 이벤트가 수신되지 않았거나, 이 대행사에 대해 구성된 이벤트가 없습니다.",
                    "REVENUE_EVENT": "수익 이벤트",
                    "SELECT_ALL_EVENTS": "모두 선택",
                    "CLEAR_ALL_EVENTS": "모두 지우기",
                    "ALL_EVENTS_SELECTED": "모든 이벤트가 선택되었습니다",
                    "NO_MATCHING_EVENTS": "일치하는 이벤트가 없습니다"
                },
                "PLACEHOLDER": {
                    "SDK_EVENTS_SEARCH": "SDK 이벤트 검색..."
                }
            },
            "SHARED_REPORTS": {
                "SHELF_TITLE": "공유 된 보고서",
                "NOTE": "링크를 보유한 누구나 접근할 수 있습니다. 반드시 리포트는 제한적인 데이터만 포함하고, 공유 시 철저한 보안이 필요합니다. " +
                    "<br/> Learn more in the <a href=\"https://support.singular.net/hc/ko/articles/360046877232\" style=\"font-weight: 400 \" target=\"_blank\">Shared Reports FAQ</a>.",
                "GENERATE_REPORT_SECTION_HEADER": "보고서 링크 생성",
                "REPORT_NAME": "보고서 이름:",
                "REPORT_NAME_HINT": "리포트 이름 설정",
                "PASSWORD": "암호 설정 (추천사항):",
                "PASSWORD_HINT": "암호를 입력하십시오",
                "DATES": "기간:",
                "SPECIFY_DATE_RANGE_FALSE": "지정된 날짜 범위의 데이터만 허용",
                "SPECIFY_DATE_RANGE_TRUE": "只显示指定期间的数据",
                "LINK_EXPIRATION": "링크 만료:",
                "GENERATED_LINKS": "발급된 링크 ",
                "NO_EXISTING_REPORTS": "발급된 링크 없음",
                "EMPTY_STATE": "아직 공유된 보고서가 없습니다. 보고서를 공유하려면 대시보드에서 보고서를 생성하고 공유하십시오.",
                "EXPIRES": "만료일",
                "DELETE_REPORT": "리포트 삭제",
                "OPEN_REPORT_IN_SINGULAR": "싱귤러 대시보드를 통해 리포트 오픈",
                "COPY_BUTTON": "링크 복사",
                "CLOSE": "닫기",
                "LINK_UNIT": "일",
                "GENERATE_LINK_BUTTON": "링크 생성",
            },
            "NEW_ALERT": {
                "PREAMBLE": "알림 받기를 원하는 조건을 정의하세요 <a href=\"https://singular.zendesk.com/hc/en-us/articles/207429303-How-to-Use-Alerts-Part-2-Configuration\" class=\"link-underline\" target=\"_blank\" ng-click=\"reportLink($event)\">알림 정의에 대해 자세히 알아보기</a>",
                "ALERT_ME_WHEN": "때 알림을 보내주세요:",
                "SEND_EMAIL_TO": "에게 이메일 보내기:",
                "PLACEHOLDERS": {
                    "ALERT_TITLE": "알림 타이틀",
                    "FILTER_VALUES": "필터 값(선택사항)",
                    "METRIC": "매트릭스",
                    "NOTES": "이메일에 메모추가",
                    "EMAIL": "이메일 주소"
                },
                "ALERT_STATUS": "알림 상태",
                "CHECK_ALERT_ON_EACH": "각 알림을 체크"
            },
            "APPS_CONFIGURATION": {
                "DEFAULT_STORE_URL": "기본 마켓 URL",
                "STORE_URL": "Store URL:",
                "MOVE_TO": "...로 이동",
                "SDK_APP_ID": "SDK App ID",
                "CREATE_OR_SEARCH": "앱 찾기 또는 생성",
                "REATTRIBUTION_WINDOW": "리인게이지먼트 비활성화 기간",
                "ATTRIBUTION_CONFIGURATION": "어트리뷰션 설정",
                "STORE_ID": "Site Public ID",
                "ADD_SITE": "사이트 추가",
                "SITE_NICKNAME": "Site Nickname",
                "PLACEHOLDERS": { "OPTIONAL": "선택사항", "CHOOSE_PLATFORM": "플랫폼 선택" },
                "DESTINATION_URLS": "랜딩 URLs:"
            },
            "CUSTOM_DIMENSIONS": {
                "VALUE_NAME": "값 이름:",
                "IF_NO_VALUE_MATCHED_SET_DEFAULT_TO": "값이 매치하지 않는경우 기본 값으로 설정: <em>(선택사항)</em>",
                "ADD_VALUE": "값을 추가",
                "USE_VALUE_WHEN": "이때 이 값을 사용하시오:",
                "PLACEHOLDERS": {
                    "FILTER_CONDITION": "조건",
                    "VALUE_NAME": "예. 뉴욕",
                    "FILTER_VALUE": "값",
                    "FILTER_DIMENSION": "디멘션을 선택",
                    "VALUE": "값을 선택하거나 새로운 값을 입력해 주세요",
                    "DIMENSION_NAME": "예. 도시"
                },
                "NO": "아니오, 생각을 바꿨습니다",
                "PREAMBLE": "성과분석을 더 포괄적이고 더 단순하게 하기위해 데이터를 분류하세요. <a href=\"https://singular.zendesk.com/hc/en-us/articles/208579346-Creating-Custom-Dimensions\" class=\"link-underline\" target=\"_blank\" ng-click=\"reportLink($event)\">커스텀 디멘션 정의에 대해 자세히 알아보기</a>",
                "DELETE_WARNING": "맵핑 데이터 기록이 삭제됩니다. <br/> 계속 진행할까요?",
                "DIMENSION_NAME": "디멘션 이름:",
                "HELP_TOOLTIP": "지정된 기본 값이 없을 경우, 값은 \"N/A\"로 정의됩니다.",
                "YES": "예, {{deleteType}}을 삭제하세요",
                "DEFINE_VALUES": "디멘션의 값을 정의하여 주세요",
                "SAVE_ANYWAY": "저장",
                "GOALS_AFFECTED_BY_CHANGE_WARNING": "해당 디멘션의 변경은 현재 사용중인 목표에 영향을 끼칠 수 있습니다. 그래도 변경하시겠습니까?"
            },
            "DATA_SOURCES": {
                "SETTINGS": {
                    "ACCOUNTS_ACTIVATE": {
                        "AUTOMATICALLY": "새로운 계정을 자동적으로 활성화",
                        "TITLE": "활성화하고자 하는 계정을 선택"
                    },
                    "GENERAL": {
                        "DESC1": "인스타그램 애드네트워크에 인스타그램 캠페인을 지정",
                        "DESC2": "캠페인은 기본적으로 계정에 정의된 소스로  지정된다(아래) ",
                        "TITLE": "일반 설정"
                    }
                },
                "GROUP_TITLES": {
                    "Pending Integration": "연동 대기중",
                    "Action Required": "필요한 액션",
                    "Live Data": "실시간 데이터",
                    "Unavailable": "이용할 수 없는"
                },
                "WARNING": "로그인 정보를 확인해 주세요",
                "LAST_LOGIN": "마지막 로그인",
                "LAST_SUCCESSFUL_LOGIN": "최근의 성공적인 로그인",
                "PLACEHOLDERS": { "ADD_DATA_SOURCE": "유입경로를 타입하여 추가하여 주세요" },
                "REAUTHORIZE": "재인증"
            },
            "ALERTS": {
                "LEARN_MORE": "<a href=\"https://singular.zendesk.com/hc/en-us/articles/207429293-How-to-Use-Alerts-Part-1-Overview-FAQs\" class=\"link-underline\" target=\"_blank\" ng-click=\"reportLink($event)\">알림정의에 대해서 자세히 알아보기</a>",
                "NOTE": "참고:필요한 Ad 네트워크의 데이터를 사용 할 수 있는 경우 알림이 실행됩니다",
                "P1": "귀사의 캠페인 비용 및/또는 실적이 추가 조사 할 가치가 있는 특정 기준을 충족시키는지에 대한 알림을 작성합니다",
                "NEW_ALERT": "새로운 알림"
            },
            "NEW_GOAL": {
                "SUB_GOALS": "서브 목표",
                "BREAKDOWNS_TITLE": "내역",
                "METRIC": "메트릭스",
                "GOAL_NAME": "목표의 이름",
                "BREAKDOWNS": { "Platforms": "플랫폼", "Country": "나라", "Apps": "앱", "Ad Networks": "애드네트워크" },
                "DURATION": "기간",
                "TOTAL_BUDGET": "총 예산"
            },
            "API": {
                "REPORTING_API_KEY": {
                    "DESC2": "<strong>Note:</strong> 올바른 Singular SDK의 키가 아닙니다 (아래를 참조하여 주세요)",
                    "DESC3": "좀더 자세한 정보는, <a href=\"http://docs.singular1.apiary.io/#\" target=\"_blank\">API 문서</a> 를 통해 확인할 수 있습니다",
                    "DESC1": "API를 통해 귀사의 서비스와 연동시키기 위해서는 API키가 필요합니다. 단, API는 비공개 및 기밀로 유지될 필요가 있습니다!",
                    "KEY": "키",
                    "TITLE": "보고서 API의 키"
                },
                "SDK_API_KEY": {
                    "NOTE": "<strong> Note: </strong> 올바른 Singular 보고서의 API 키가 아닙니다 (위를 참조하여 주세요)",
                    "FOR_MORE_INFORMATION": "좀더 상세한 정보가 필요하실 경우에는 편하게, 문의 주시기 바랍니다",
                    "DESC1": "Sigular Stack과의 연동을 위해 SDK API 키가 필요합니다",
                    "DESC2": "SDK 연동을 원하실 경우에는 문의 주시기 바랍니다",
                    "TITLE": "SDK API 키"
                }
            },
            "TWO_FACTOR_AUTH_CONFIG": {
                "STEP_1": {
                    "INSTRUCTIONS": "아래에 있는 인증 앱 중 <a href=\"https://m.google.com/authenticator\" target=\"_blank\">Google Authenticator</a>, <a href=\"http://guide.duosecurity.com/\" target=\"_blank\">Duo Mobile</a>, <a href=\"https://www.authy.com/\" target=\"_blank\">Authy</a>, <a href=\"https://www.windowsphone.com/en-us/store/app/authenticator/e7994dbc-2336-4950-91ba-ca22d653759b\" target=\"_blank\">Windows Phone Authenticator</a> -하나를 휴대폰이나 태블릿에 설치하세요",
                    "DESCRIPTION": "앱 가져 오기",
                    "TITLE": "1단계"
                },
                "STEP_3": {
                    "INSTRUCTIONS": "앱에서 생성된 6자리 확인 코드를 아래에 입력하여 주세요",
                    "DESCRIPTION": "인증 코드 입력",
                    "TITLE": "3단계"
                },
                "STEP_2": {
                    // "  <A16><A17>{{code}}<A/17></A16> <A18> 그러면 앱에서 아래에서 사용할 수 있는 6자리 확인 코드가 생성됩니다."
                    "HELP": "스캔하는 대신, 인증앱의 \"수동입력\" 또는 이와 동등한 옵션을 사용하고 다음과 같은 시간기반의 키를 제공하여 주세요 </p> <p><code>{{code}}</code></p> <p> 그러면 앱에서 아래에서 사용할 수 있는 6자리 확인 코드가 생성됩니다.",
                    "INSTRUCTIONS": "인증 앱을 실행하고: <ul><li> \"+\" 또는 \"계정 추가\" 아이콘을 누른 후,</li><li>휴대폰의 카메라를 이용하여 왼쪽부터 이미지를 스캔하여 주세요</li></ul>",
                    "DESCRIPTION": "바코드를 스캔",
                    "TITLE": "2단계"
                },
                "PREAMBLE": "설정 후에는, 싱귤러의 계정에 접속하기 위해 인증앱을 통해 생성된 코드를 입력할 필요가 있습니다"
            },
            "GOALS": {
                "NO_GOALS_MSG": "목표를 아직 설정되지 않았습니다. 새로운 목표를 추가하려면 <a class=\"new-goal-link\" href=\"#/goals/new\" class=\"text-success create-goal\">여기를</a> 클릭하십시오.",
                "NO_GOALS_TEXT": "아직 goal이 설정되지 않았습니다"
            },
            "CUSTOM_EVENTS": {
                "MAP_TO": "이벤트는 다음과 같이 매핑됩니다.",
                "ADD_CALCULATED_METRIC_BASED_ON_EVENT": "이벤트를 기준으로 계산된 메트릭을 추가",
                "HELP_TOOLTIP": "CPE = Cost/Event (비용/이벤트). <br> eCVR = Events/Installs (이벤트/설치). <br> 메트릭스 이름에 '이벤트'가 이벤트 이름으로 바뀝니다, 예. CPRegister",
                "PLACEHOLDERS": {
                    "FILTER_VALUES": "필터값 선택",
                    "EVENT_NAME": "e.g. My Custom Event"
                },
                "LAST_MODIFIED": "마지막 수정{{date}} by {{editor}}",
                "LAST_MODIFIED_AUTOMATICALLY": "마지막 수정{{date}}, 자동 생성됨.",
                "EVENTS_CONT": "Events (${number})",
                "GLOBAL_EVENTS_CONT": "Global (${number})",
                "APP_SPECIFIC_CONT": "App Specific Events (${number})",
                "NO_EVENTS": "You haven’t created any events yet",
                "HELP": "To learn more, please visit our <a href=\"https://singular.zendesk.com/hc/en-us/articles/208385833\" class=\"link-underline\" target=\"_blank\" ng-click=\"reportLink($event)\">Help Center</a>",
                "MAP_TO_REACT": "Custom Event maps to the following",
                "MAP_TO_REACT_UNIQUE": "Custom Event maps to the following (showing only unique source events)",
                "AUTO_GENERATED": "(auto-generated)",
                "MAX_EVENTS": "A maximum of {{maximumEventSlots}} Custom Events are possible per Account",
                "EVENT_DATA_NOTE": "Please Note that event data up to 1 month back will be retrieved retroactivly",
                "EVENT_AT_LEAST_ONE_EVENT_ERROR": "Please add at least one in-app event",
                "EVENT_AT_LEAST_ONE_EVENT_ERROR_REACT": "Please add at least one source event",
                "SAVE_SERVER_ERROR": "An error has occurred while processing your request",
                "EVENT_NAME_ERROR": "Please add an event name",
                "UNIQUE_TOGGLE_LABEL": "Unique Custom Event",
                "UNIQUE_TOGGLE_INFO": "When turned on, you will only be able to map source events which count uniques (as opposed to totals) to this event.",
                "UNIQUE_TOGGLE_DISABLE_INFO": "This custom event already have<br/>mapped ${eventType} source events.",
                "APP_SELECTION_AUTOCOMPLETE_PLACEHOLDER": "Select an app to configure custom events...",
                "EMPTY_STATE_NO_CUSTOM_EVENTS": "No custom events created yet.",
                "EMPTY_STATE_NO_APP_SELECTED": "Please select an app.",
                "EMPTY_STATE_NO_CUSTOM_EVENTS_FOR_APP": "No app specific custom events created yet.",
                "EMPTY_STATE_NO_UAN_EVENTS": "No source events found.",
                "REACHED_MAXIMUM_WARNING": "You cannot add additional custom events because this app already has the maximum of ${maxEvents} custom events.",
                "REACHED_MAXIMUM_GLOBAL_WARNING": "You cannot add additional global custom events because one of your apps already has the maximum of ${maxEvents} custom events. In order to add global custom events, each app much have fewer than ${maxEvents} custom events set up.<br/>Please contact support for further assistance.",
                "NEAR_MAXIMUM_GLOBAL_WARNING": "Please be aware that one of your apps has reached ${maxAppEvents} out of ${maxEvents} custom events. Once the app has ${maxEvents} custom events, you will not be able to add new global custom events.",
                "UNSAVED_CHANGES_WARNING": "You have unsaved changes, are you sure you want to discard them?",
                "GLOBAL_EVENTS": "Global Events",
                "APP_SPECIFIC_EVENTS": "App Specific Events",
                "LOCKED_UAN_EVENT_ALT": "Once mapped, existing source events cannot be removed as that would cause data deletion"
            },
            "GENERATE_TRACKING_LINK": {
                "CAMPAIGN_NAME": "캠페인 이름",
                "CREATIVE_NAME": "크리에이티브 이름",
                "DESTINATION_URL": "랜딩 URL",
                "SITE": "사이트",
                "APP": "@:STATIC.APP",
                "SOURCE": "@:STATIC.SOURCE",
                "EDIT": "@:STATIC.BUTTONS.EDIT",
                "GENERATE_LINK": "링크 생성",
                "SOURCE_CONFIG": "경로 설정",
                "PLEASE_CONFIG_THIS_SOURCE": "해당 경로를 설정해 주세요",
                "CONFIG": "설정",
                "CAMPAIGN_NAME_TOOLTIP": "캠페인 이름은 최대한 자세히 정의해 주세요",
                "ENABLE_RETARGETING_TOOLTIP": "해당 트랙킹 링크가 리타겟팅 캠페인으로 사용될 경우, 활성화해 주세요",
                "CLICK_THROUGH_LINK": "Click-through 트랙킹 링크",
                "PLACEHOLDER": {
                    "SITE": "사이트 선택",
                    "DESTINATION_URL": "목적지(랜딩) 선택",
                    "CAMPAIGN_NAME": "캠페인 이름 입력",
                    "CREATIVE_NAME": "크리에이티브 이름 입력 (선택)",
                    "ADNET": "애드네트워크 찾기",
                    "SELECT_APP": "@:STATIC.PLACEHOLDERS.SELECT_APP"

                },
                "MODAL": {
                    "TITLE": "{{adnname}} Configuration",
                    "TITLE_NO_NAME": "Source Configuration",
                    "APP_SPECIFIC_CONFIGURATION": "앱 상세 설정",
                    "SITE": "@:STATIC.PAGES.GENERATE_TRACKING_LINK.SITE",
                    "APP": "@:STATIC.APP",
                    "MANDATORY_FIELD": "해당 항목은 필수 입니다",
                    "PLEASE_FILL_THIS_FIELD": "해당 항목을 입력해 주세요",
                    "CLICK_THROUGH_ATTRIBUTION_WINDOW": "Click-through 어트리뷰션 룩백 윈도우",
                    "VIEW_THROUGH_ATTRIBUTION_WINDOW": "View-through 어트리뷰션 룩백 윈도우",
                    "EVENT_POSTBACKS": "이벤트 포스트백",
                    "SEND_IN_APP_EVENTS_TO": "인 앱 이벤트를 {{adnname}}로 송신",
                    "CLICK_TO_ADD_NEW_EVENT": "새로운 이벤트를 추가하려면 <button type=\"button\" class=\"button-add btn-link text-hide\" title=\"Add\" ng-click=\"addEvent()\" ng-disabled=\"isInAppEventsSendingDisabled()\">+</button> 를 누르세요",
                    "SDK_EVENT_NAME": "인 앱 (SDK) 이벤트 이름",
                    "ADN_EVENT_NAME": "{{adnname}} 이벤트 이름",
                    "SEND_VALUE": "값을 송신",
                    "PLEASE_SELECT_EVENT": "이벤트를 선택해 주세요",
                    "PLEASE_SELECT_EVENT_NAME": "이벤트 이름을 선택해 주세요",
                    "PLEASE_ENTER_EVENT": "이벤트를 입력해 주세요",
                    "ALLOW_NO_POSTBACKS_NETWORKS": "몇 네트워크에서는 인스톨에 대한 모든 포스트백을 필요로 합니다 (네크워크를 통한 인스톨 이외에도) - 이를 허용하기 위해서는 체크박스를 표시해 주세요",
                    "SEND_ALL_POSTBACKS_TO_ADN": "{{adnname}} 의 모든 인스톨에 대한 포스트백 송신",
                    "SOURCE_DOESNT_SUPPORT_EVENT_POSTBACKS": "→ 해당 경로는 이벤트 포스트백을 지원하지 않습니다.",
                    "ENABLE_VIEW_THROUGH": "View-through 어트리뷰션 활성화"
                }
            },

            "EXPORT_LOGS": {
                "DATE": "날짜",
                "TIMEZONE": "시간대",
                "TYPE": "종류",
                "APP": "앱",
                "SITE": "사이트",
                "EXPORT": "추출",
                "ERROR_MSG": "요청을 다시 확인해 주세요",
                "FOLLOW_YOUR_REQUEST": "요청에 따라",
                "FIELDS_UPDATED": "다음 필드들은 사용 불가능하며 자동으로 제거됐습니다.",
                "TYPES": {
                    "Installs": "Conversions",
                    "Postbacks": "Postbacks",
                    "Events": "Events",
                    "Clicks": "Clicks",
                    "Links": "Links"
                },
            },
            "SHARED_LINKS": {
                "REPORT_NAME": "공유 리포트 열람:",
            },
            "ANONYMOUS": {
                "MODAL_TITLE": "공유 리포트 열람",
                "MODAL_PLACEHOLDER": "공유받은 암호를 입력하십시오",
                "MODAL_LABEL": "암호:",
                "ERROR_INVALID_EMAIL": "잘못된 암호를 입력하셨습니다",
                "ERROR_EXPIRED": "리포트 기간이 만료되었습니다, 담당자에 새로운 리포트 공유를 요청하세요",
                "ERROR_INVALID": "잘못된 리포트입니다"
            },
            "REPORTS": {
                "SOURCE_DRILLDOWN_PREAMBLE": "각 행을 클릭해서 매체(소스)의 지표 별 수치 구분을 확인하세요. <a href=\"https://singular.zendesk.com/knowledge/articles/213519803/en-us?brand_id=188619\" class=\"link-underline\">Learn more</a>",
                "PERFORMANCE_WARNING": "<div> 날짜 혹은 캠페인 별 구분은 일부 시간이 소요될 수 있습니다.</div><div>더 빠른 리포트를 위해 더 상세하게 기간을 설정 해 주세요.</div>",
                "PUBLISHER_PERFORMANCE_WARNING": "<div>퍼블리셔별 구분은 큰 용량의 데이터를 발생시킵니다.</div><div>특정 앱 및 매체(소스)로 필터를 설정 해 주세요</div>",
                "ADMON_DAU_WARNING": "<div>DAU and ARPDAU are only available for the dimensions app, OS, and/or country.</div>",
                "ADMON_DAU_METRICS_SUB_TEXT": "Available for <a href=\"https://support.singular.net/hc/ko/articles/360022067552-Ad-Monetization-Analytics-FAQ#User_Activity_Metrics_DAU_and_ARPDAU\" target='_blank'>selected dimensions</a>",
                "UNIFIED_BANNER": {
                    "HEADER": "SKAN 및 iOS 인사이트 확인",
                    "SUB_HEADER": "SKAN과 트래커 데이터를 통합하여 iOS 설치 및 수익에 대해 중복 제거된 하나의 정확한 뷰를 제공합니다.",
                },
                "BOOKMARKS": {
                    "TITLE": "다른 이름으로 저장:",
                    "PLACEHOLDER_REPORT_NAME": "소스 별 앱",
                    "TIME_PERIOD": "기간대 설정",
                    "ROLLING_PERIOD": "롤링",
                    "STATIC_PERIOD": "통계",
                    "PUBLIC": "공유하기",
                    "REMOVE": "제거",
                    "SAVE": "@:STATIC.BUTTONS.SAVE",
                    "LAST_DAYS_BACK_1": "",
                    "LAST_DAYS_BACK_2": "days back",
                    "COMPARISON_GAP_1": "Ending",
                    "COMPARISON_GAP_2": "days before"
                },
                "TOOLTIPS": {
                    "network": {
                        "SINGLE": "${metric} 는 네트워크에서 추출되었습니다",
                        "PLURAL": "${metric} 는 네트워크에서 추출되었습니다",
                    },
                    "tracker": {
                        "SINGLE": "${metric} 는 트래커에서 추출되었습니다",
                        "PLURAL": "${metric} 는 트래커에서 추출되었습니다",
                    },
                    "mixed": {
                        "SINGLE": "${metric} 는 이용자의 설정에 따라 매체와 트래커 모두에서 추출되었습니다",
                        "PLURAL": "${metric} 는 이용자의 설정에 따라 매체와 트래커 모두에서 추출되었습니다",
                    },
                    "custom": {
                        "SINGLE": "${metric} 는 해당 어카운트의 설정에 따라 계산된 값입니다",
                        "PLURAL": "${metric} 는 해당 어카운트의 설정에 따라 계산된 값입니다",
                    },
                },
                "CHART_NO_DATA": "표시할 데이터가 없습니다",
                "CHART_METRIC_NO_DATA": "선택하신 조건에는 데이터를 추출하실 수 없습니다",
                "CHART_MAX_REACHED": "${max} 개 이상의 조건을 설정하실 수 없습니다",
                "REPORT": "보고서",
                "CREATED_BY": "작성자",
                "DATEPICKER_PERIOD_TITLE": "기간 (${daysPeriod} 일)",
                "DATEPICKER_PREVIOUS_PERIOD_TITLE": "지난 (${daysPeriod} 일)",
                "GOAL_WARNING": "해당 goal의 종료기간은 현재보다 이후로 설정되어 있어 모든 데이터가 표시되지 않습니다.",
                "GOAL_WARNING_2": "해당 goal은 현재보다 이후 시점으로 설정되어 있어 데이터가 표시되지 않습니다.",
                "COMPARE_WARNING": "비교하려는 데이터의 기간이 서로 다릅니다",
                "VALIDATION_ERROR_SELECT_GOAL": "goal을 설정해 주세요",
                "VALIDATION_ERROR_SELECT_METRIC": "최소 1개의 조건(metric)을 선택 해 주세요",
                "VALIDATION_ERROR_ALLOWED_DIMENSIONS": "DAU and ARPDAU are not available for the dimensions you selected. To run a report with DAU and/or ARPDAU, remove all dimensions except for app, OS, and country.",
                "VALIDATION_ERROR_PERIOD_FOR_COHORT": "조건(metric) 혹은 커스텀 이벤트를 선택 시 최소 1개의 기간이 선택되어야 합니다",
                "VALIDATION_ERROR_FUTURE_GOAL": "현재보다 이후의 시간대는 설정하실 수 없습니다.",
                "VALIDATION_ERROR_GRANULARITY": "최소 1개의 granularity level+file combiner dimension을 설정 해 주세요.",
                "VALIDATION_ERROR_PUBLISHER": "퍼블리셔 별 데이터는 1개의 앱과 매체(source)로 필터가 필요합니다.",
                "TRANSPARENCY": {
                    "METRIC_DRILLDOWN": "Metric Drilldown"
                },
            },
            "DELETE_MODAL": {
                "WARNING_P1": "{{deleteType}} - 해당 설정을 정말로 삭제하시겠습니까?",
                "WARNING_P2": "이 설정은 영구적이며, 해당 계정을 포함한 귀사의 모든 사용자에 영향을 미치게 됩니다",
                "DELETE_NO": "아니요, 생각을 바꿨습니다",
                "DELETE_YES": "네, 삭제하겠습니다.",
                "DELETE_YES_REACT": "네, 삭제하겠습니다.",
                "TYPES": {
                    "PARTNER_CONFIG": "파트너 설정",
                    "SITE_CONFIG": "사이트 설정",
                },
            },
            "PARTNER_CONFIGURATION": {
                "EMPTY_STATE_HEADER": "첫 번째 파트너를 추가하여 시작하세요",
                "EMPTY_STATE_SUB_HEADER": "파트너 구성은 파트너에게 전송되는 이벤트를 정의합니다.",
                "EMPTY_STATE_NEW_UAN_PLACEHOLDER": "파트너 검색",
                "EMPTY_STATE_DROPDOWN_HOVER": "새로운 파트너 추가",
                "CHOOSE_TOP_NETWORK": "또는 상위 파트너에서 선택하세요",
                "ADD_PARTNER": "파트너 추가",
                "ADD_APP_SITE": "앱 사이트 추가",
                "EXPORT_ALL": "모든 데이터 다운로드",
                "EXPORT_ALL_FAILURE_MESSAGE": "다운로드 실패",
                "USER_CONFIGURATION": "사용자 설정",
                "ALL_USERS": "소스에 관계없이 ${partnerName}에게 포스트백을 전송합니다",
                "ALL_USERS_EVENT": "소스에 관계없이 ${partnerName}에게 이벤트 중 하나 이상의 포스트백을 전송합니다",
                "ATTRIBUTED": "${partnerName}에서 유입된 사용자에게만 포스트백을 전송합니다",
                "LIMITED_DATA_SHARING": "제한된 데이터 공유",
                "RESTRICTED": "제한됨",
                "NOT_RESTRICTED": "제한 없음",
                "DELETE_CONFIGURATION_MESSAGE": "이 파트너 설정을 영구적으로 삭제하시겠습니까?",
                "MISSING_SITE": "이 포스트백은 활성화되었지만 앱 사이트를 사용할 수 없습니다. 삭제되었거나 '테스트 앱'으로 이동되었습니다. 앱 페이지에서 설정을 관리할 수 있습니다.",
                "FILTER": "필터링:",
                "FILTER_PLACEHOLDER": "필터...",
                "TABLE_COLUMNS": {
                    "APP_SITE": "앱 사이트",
                    "CLICK_THROUGH_WINDOW": "클릭 쓰루 창",
                    "POSTBACKS_TO_PARTNER": "파트너에 포스트백 보내기",
                    "LAST_EDITED": "마지막 편집",
                    "PRIVACY": "개인 정보",
                },
                "ATTRIBUTED_TYPES": {
                    "ATTRIBUTED": "속성",
                    "ALL_USERS": "모든 사용자",
                },
                "POSTBACK_TYPES": {
                    "REVENUE": "수익",
                    "EVENTS": "${eventsCount} 이벤트",
                    "NO_EVENTS": "이벤트 없음",
                    "INSTALL": "설치",
                    "REENGAGEMENT": "재참여",
                }
            },
            "ONBOARDING_GUIDE": {
                "PAGE_HEADER": "환영합니다!",
                "PAGE_SUB_HEADER": "시작하려면 아래 작업을 완료하세요:",
                "MENU_HEADERS": {
                    "BASIC_SET_UP_CATEGORY": "시작하기",
                    "SET_UP_CAMPAIGNS_CATEGORY": "캠페인 실행 시작",
                    "VIEW_DATA_CATEGORY": "데이터 분석",
                    "SKAN_CATEGORY": "iOS 14 및 SKAdNetwork 캠페인 시작",
                    "ADMON_CATEGORY": "광고 수익화 시작"
                },
                "MENU_ITEMS": {
                    "BASIC_SET_UP_INTRO": "환영합니다",
                    "SETUP_YOUR_APPS": "앱 설정하기",
                    "APPS": "앱 추가",
                    "SDK_INTEGRATION_SUBCATEGORY": "Singular SDK 통합",
                    "SETUP_YOUR_SOURCES": "매체 소스 설정하기",
                    "AUDIT_REPORT": "감사 보고서 실행",
                    "VALIDATE_SETUP": "설정 유효성 검사",
                    "PARTNER_CONFIGURATION_SUBCATEGORY": "어트리뷰션 설정",
                    "PARTNER_CONFIGURATION": "어트리뷰션 설정하기",
                    "DATA_CONNECTORS_SUBCATEGORY": "데이터 커넥터 설정",
                    "DATA_CONNECTORS": "데이터 커넥터 추가",
                    "MANAGE_LINKS": "트래킹 링크 생성하기",
                    "CUSTOM_SOURCES_LINKS": "커스텀 링크 생성하기",
                    "TEST_LINKS": "트래킹 링크 테스트",
                    "DEEP_LINKING": "딥링크 캠페인 생성",
                    "RUN_REPORT": "보고서 보기",
                    "VISUALIZE_CAMPAIGNS": "캠페인 성과 시각화",
                    "COHORTED_EVENTS": "이벤트 추가",
                    "REPORTS": "다양한 보고서 유형 알아보기",
                    "REPORTS_AND_PIVOTS": "보고서 및 피벗 알아보기",
                    "RUN_ADDITIONAL_REPORT": "추가 보고서 알아보기",
                    "EXPORT_DATA": "데이터 내보내기 (ETL/API)",
                    "ETL": "데이터 전송 가이드",
                    "SKAN_INTRO": "Singular의 SKAdNetwork 솔루션 소개",
                    "SKAN_FACEBOOK": "SKAN 및 Facebook",
                    "SKAN_ADWORDS": "SKAN 및 Google Ads",
                    "SKAN_CONVERSION_MODEL": "SKAN 전환 모델",
                    "SKAN_PROBABILISTIC": "확률적 어트리뷰션 사용하기",
                    "SKAN_REPORTING": "SKAdNetwork 보고서 실행",
                    "ADMON_INTRO": "광고 수익화 설정",
                    "ADMON_ANALYZE": "광고 수익화 분석",
                    "ADMON_SETUP_REVENUE": "광고 수익 이벤트 설정",
                    "ADMON_EXPORT": "광고 수익 데이터 내보내기",
                    "SDK_INTEGRATION": "Singular SDK 통합",
                    "SDK_CONSOLE_TESTING": "SDK 통합 테스트",
                    "WEB_SDK_INTEGRATION": "웹 어트리뷰션 설정",
                    "SDK_CONFIGURATION": "온보딩 계획 수립",
                    "SDK_CONSOLE_BASIC_EVENTS": "이벤트 추가",
                    "DEBUGGING_TOOLS": "디버깅 도구:",
                    "ADVANCED_SETUP": "고급 설정:",
                    "SET_UP_FACEBOOK": "Meta Ads / Instagram 설정",
                    "SET_UP_GOOGLE": "Google Ads 설정",
                    "SET_UP_APPLE_SEARCH_ADS": "Apple Search Ads 설정"
                },
                "CONTENT_TITLE": {
                    "BASIC_SET_UP_INTRO": "Singular에 오신 것을 환영합니다",
                    "APPS": "앱을 추가하는 방법:",
                    "SDK_INTEGRATION": "Singular SDK 통합하기",
                    "SDK_CONSOLE_TESTING": "SDK 콘솔로 테스트하기",
                    "SDK_CONSOLE_BASIC_EVENTS": "어떤 이벤트를 테스트할지",
                    "PARTNER_CONFIGURATION": "파트너 설정 구성하기",
                    "GET_STARTED_FACEBOOK": "Facebook 파트너 설정 구성하기",
                    "GET_STARTED_ADWORDS": "Google Ads 파트너 설정 구성하기",
                    "DATA_CONNECTORS": "소스용 데이터 커넥터 추가하기",
                    "SET_UP_FACEBOOK": "Facebook용 데이터 커넥터 설정",
                    "SET_UP_GOOGLE": "Google Ads용 데이터 커넥터 설정",
                    "VALIDATE_SETUP": "설정 및 SDK 감사 리포트 실행",
                    "MANAGE_LINKS": "트래킹 링크 생성 및 관리",
                    "CUSTOM_SOURCES_LINKS": "셀프 운영 채널로 캠페인 실행",
                    "TEST_LINKS": "트래킹 링크 테스트하기",
                    "DEEP_LINKING": "딥링크로 캠페인 실행하기",
                    "RUN_REPORT": "캠페인 리포트 실행",
                    "VISUALIZE_CAMPAIGNS": "캠페인 성과 시각화",
                    "COHORTED_EVENTS": "이벤트 추가하기",
                    "REPORTS_AND_PIVOTS": "보고서 및 피벗 알아보기",
                    "ADVANCED_REPORTING": "고급 보고 설정",
                    "RUN_ADDITIONAL_REPORT": "추가 리포트 알아보기",
                    "EXPORT_DATA": "데이터에 접근하는 다양한 방법 살펴보기",
                    "REPORTING_API": "Singular API 가이드",
                    "BI_POSTBACKS": "BI 포스트백 가이드",
                    "ETL": "데이터 전송(ETL) 가이드",
                    "SKAN_INTRO": "Singular의 SKAdNetwork 솔루션 소개",
                    "SKAN_FACEBOOK": "SKAN과 Facebook",
                    "SKAN_ADWORDS": "SKAN과 Google Ads",
                    "SKAN_CONVERSION_MODEL": "전환 모델 설정",
                    "SKAN_PROBABILISTIC": "확률적 어트리뷰션 사용하기",
                    "SKAN_REPORTING": "SKAdNetwork 리포트 실행",
                    "ADMON_INTRO": "광고 수익화 시작하기",
                    "ADMON_ANALYZE": "광고 수익화 분석 방법",
                    "ADMON_SETUP_REVENUE": "광고 수익 ROI 설정 시작",
                    "ADMON_EXPORT": "광고 수익 데이터 내보내기"
                },
                "CONTENT": {
                    "BASIC_SET_UP_INTRO": "Singular에 오신 것을 환영합니다! 시작할 준비가 되셨나요? 이 가이드는 캠페인을 실행할 수 있도록 설정하는 방법을 안내합니다. 또한 Singular가 제공하는 다양한 분석 제품에 대한 개요도 제공됩니다.<br /><br />" +
                        "iOS 및 SKAdNetwork 관련 시작 가이드를 찾고 계신가요? <br />아래 가이드로 바로 이동하세요.<br /><br />" +
                        "여기서 원하는 정보를 찾을 수 없다면 언제든지 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko'>헬프센터</a>를 참고하세요.",
                    "APPS": "Singular에 오신 것을 환영합니다! 앱을 추가하여 Singular가 데이터를 수신할 수 있도록 설정을 시작해 보세요.<br/>" +
                        "같은 앱이 Android와 iOS 모두에 있는 경우, 동일한 앱 내에 두 개의 '앱 사이트'로 추가할 수 있습니다. 단계별 안내는 아래를 참고하세요.<br /><br />" +
                        "설정 방법:" +
                        "<ol>" +
                        "<li><strong>설정 > 앱</strong>로 이동합니다.</li>" +
                        "<li>앱이 자동으로 추가되지 않은 경우, <strong>Add New App</strong>을 클릭합니다.</li>" +
                        "<li>새로 생성된 앱에서 앱 이름을 입력하고 정확한 철자를 확인합니다.</li>" +
                        "<li>앱이 배포될 플랫폼(iOS, Android 등)을 선택합니다.</li>" +
                        "<li>앱이 이미 스토어에 등록되어 있는 경우, <strong>Store URL</strong> 필드에 앱 스토어 URL을 붙여넣고 <strong>Save</strong>를 클릭합니다.</li>" +
                        "<li>(선택 사항) iOS 앱이 앱스토어 심사 중이라면 <strong>Site Public ID</strong> 필드에 appstore_id를 입력할 수 있습니다.</li>" +
                        "<li>앱이 아직 등록되지 않았다면 <strong>Bundle ID</strong> 옵션을 선택하고 앱 ID를 <strong>Bundle ID</strong> 필드에 입력한 후 <strong>Save</strong>를 클릭합니다.</li>" +
                        "</ol><br />" +
                        "<strong>질문이 있으신가요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" " +
                        "href='https://support.singular.net/hc/ko/articles/360025661232-Apps-App-Configuration-FAQ'>앱 구성 FAQ</a>를 확인해보세요.",
                    "SDK_KEYS_AND_DOCUMENTATION": "<a href='#/react/sdk_integration'><strong> SDK 계획 도구</strong></a>를 사용하여 SDK 통합을 단계별로 안내받을 수 있습니다.",
                    "SDK_CONSOLE_TESTING": "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://app.singular.net/#/react/testing-console'>개발자 도구 > 테스트 콘솔</a>을 사용하여 SDK 통합을 테스트할 수 있습니다. " +
                        "콘솔에서는 앱 내의 세션, 이벤트 및 Singular가 SDK로부터 수신하는 기타 데이터를 확인할 수 있습니다.<br/><br/>" +
                        "시작 전에 반드시 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/115000497903-Using-the-SDK-Console'>Testing Console 가이드</a>를 읽어보세요.<br/><br/>" +
                        "<strong>시작 전 체크리스트:</strong>" +
                        "<ul style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li>앱을 설치하거나 테스트하기 전에 콘솔에 테스트 기기를 먼저 추가하세요.</li>" +
                        "<li>테스트 기기 ID를 찾을 수 없나요? Singular는 <strong>Device Assist</strong> 앱을 제공합니다. 다음에서 다운로드하세요: " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://itunes.apple.com/us/app/singular-device-assist/id1441750662?mt=8'>iOS</a> 또는 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://play.google.com/store/apps/details?id=net.singular.deviceassist2'>Android</a>.</li>" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/115000497903-Using-the-SDK-Console'>Testing Console 가이드</a>를 참고하세요.</li>" +
                        "</ul>" +
                        "<br />테스트 기기를 콘솔에 추가한 후 SDK 통합 테스트를 시작할 수 있습니다.<br />다음 항목을 확인하세요:" +
                        "<ol>" +
                        "<li><strong>설치: </strong>Singular는 새 기기에서 세션을 감지하면 설치로 인식합니다.<br />" +
                        "SDK가 세션을 정상적으로 전송하고 있는지 확인하려면:" +
                        "<ul>" +
                        "<li>iOS: SDK 시작 세션에서 'attribution_token' 파라미터에 Apple의 토큰 값이 포함되어 있는지 확인하세요.</li>" +
                        "<li>Android: 첫 세션 이벤트 후에 \"__installReferrer\"가 수신되었는지 확인하세요.</li>" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360002675072-Testing-Basic-Integration-Functionality'>Singular SDK 통합 테스트 방법</a>을 참고하세요.</li>" +
                        "</ul><br />" +
                        "</li>" +
                        "<li><strong>수익: </strong>수익 이벤트는 항상 콘솔에서 \"is_revenue\"로 표시됩니다.<br />" +
                        "<ul>" +
                        "<li>구매 객체를 전달하면 Singular가 영수증을 검증할 수 있으므로 권장됩니다. 유효한 수익만 리포트에 반영되며, 유효하지 않은 수익은 로그 내보내기 페이지에서 확인할 수 있습니다.</li>" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360002675072--UPDATED-How-to-Test-Your-Singular-SDK-Integration#Test_Events'>테스트 이벤트</a> 및 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360002675072-Testing-Basic-Integration-Functionality#Test_Revenue'>테스트 수익</a>을 참고하세요.</li>" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href=''>인앱 결제 검증 FAQ</a>를 확인하세요.</li>" +
                        "</li>" +
                        "</ul><br />" +
                        "<li><strong>사용자 식별자 (Custom User ID): </strong>사용자 식별을 통합하면 기기 간 사용자 추적이나 광고 ID가 제한된 상황에서도 유용합니다. 테스트 시 모든 이벤트에서 “Custom User ID”가 파라미터로 표시되는지 확인하세요.<br />" +
                        "</ol>",
                    "WEB_SDK_INTEGRATION": {
                        "INTEGRATION_STEPS": "<strong>웹 시작하기:</strong></br>" +
                            "<ol>" +
                            "<li>" +
                            "<strong>웹 SDK를 웹사이트에 통합하세요</strong>: 사용자 상호작용과 전환을 추적하기 위해 사이트 HTML에 몇 줄의 코드를 추가하는 작업입니다. " +
                            "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360039991491-Singular-Website-SDK-Native-Integration'>네이티브 방법</a> 또는 " +
                            "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360037640472-Singular-Website-SDK-Google-Tag-Manager-Integration'>Google 태그 관리자</a>를 사용할 수 있습니다." +
                            "</li>" +
                            "<li>" +
                            "<strong>통합을 테스트하세요</strong>: 웹 SDK가 제대로 설치되고 이벤트를 전송하는지 확인하려면, Singular SDK가 구현된 웹페이지를 로드한 후 브라우저 개발자 도구의 네트워크 탭에서 \"PAGE_VISIT\" 이벤트와 상태 코드 200을 확인하세요." +
                            "</li>" +
                            "<li>" +
                            "<strong>광고용 트래킹 링크를 설정하세요</strong>: 사용자가 웹사이트로 이동하도록 하며 SDK가 그들의 행동 데이터를 캡처할 수 있도록 합니다. " +
                            "웹 트래킹 링크에 관한 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360041317471'>여기</a>를 참고하세요." +
                            "</li>" +
                            "</ol>",
                        "FAQ": {
                            "TITLE": "자주 묻는 질문:",
                            "QUESTION_1": "앱 페이지에 여전히 “앱”을 추가해야 하나요?",
                            "ANSWER_1": "웹 도메인을 앱 페이지에 반드시 추가해야 합니다.",
                            "QUESTION_2": "리포팅에서 “설치(installs)”는 무엇으로 표시되나요?",
                            "ANSWER_2": "Singular는 기본적으로 웹 세션을 전환으로 추적합니다; 맞춤 설정을 원하면 솔루션 엔지니어에게 문의하세요.",
                            "QUESTION_3": "웹 SDK가 서로 다른 도메인이나 서브도메인 간 사용자 행동을 추적할 수 있나요?",
                            "ANSWER_3": "네, 쿠키를 이용한 자동 유지 또는 수동 유지 등 교차 서브도메인 추적 방법을 사용하여 가능합니다."
                        },
                        "LEARN_MORE": "<strong>추가로 다음 내용에 대해 문의해 보세요:</strong></br>" +
                            "<ol>" +
                            "<li>" +
                            "<strong>웹-투-앱 어트리뷰션</strong> - Singular는 웹에서 앱 설치 추적을 지원합니다. 이를 설정하려면 Singular SDK 구현에 웹-투-앱 코드를 추가하고, 기본 활성화되지 않으므로 솔루션 엔지니어와 상담하여 트래킹 링크를 만드세요. " +
                            "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360042283811-Website-to-App-Attribution-Forwarding-for-Mobile-Web'>자세히 보기</a>." +
                            "</li>" +
                            "<li>" +
                            "<strong>크로스 디바이스 어트리뷰션</strong> - 광고주가 보고한 ID를 사용해 여러 기기 및 활동을 동일 사용자로 연결하여 크로스 플랫폼 정확한 추적을 위해 사용자 인증이 필요합니다. " +
                            "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360040888232-Introduction-to-Singular-s-Cross-Device-Attribution'>자세히 보기</a>." +
                            "</li>" +
                            "<li>" +
                            "<strong>컨버전 API 통합</strong> - 서버 간 통합을 통해 광고 플랫폼에 직접 전환 데이터를 전송하여 캠페인 측정 정확도를 높입니다. " +
                            "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/categories/201687706-Attribution-and-Singular-Links#Conversion API Integrations'>통합 파트너 목록 보기</a>." +
                            "</li>" +
                            "</ol>"
                    },
                    "SDK_CONSOLE_BASIC_EVENTS": "SDK를 통해 이벤트를 성공적으로 보고하고 있다면, <strong>보고서 및 통계 > 로그 내보내기</strong>에서 이벤트별 세부 정보를 볼 수 있습니다.<br/>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li><strong>설치:</strong> Singular는 새로운 기기에서 <strong>세션</strong>이 감지되면 설치로 인식합니다. SDK가 세션을 제대로 전송하는지 확인하려면:" +
                        "<ul style=\"text-align: left;padding: 10px 0 10px 20px\">" +
                        "<li><strong>iOS의 경우:</strong> SDK 시작 세션의 ‘attribution_token’ 파라미터에서 Apple의 토큰 값을 확인하세요.</li>" +
                        "<li><strong>Android의 경우:</strong> 초기 세션 이벤트 이후 \"__installReferrer\"가 수신되는지 확인하세요.</li>" +
                        "<li>자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360002675072-Testing-Basic-Integration-Functionality'>기본 통합 기능 테스트</a>를 참조하세요.</li>" +
                        "</ul></li>" +
                        "<li><strong>수익:</strong> 문서에서 보셨듯, 수익을 Singular에 전송하는 다양한 방법이 있습니다. 어떤 방법을 사용하든, 수익 이벤트는 SDK 콘솔에서 \"is_revenue\"로 표시되어야 합니다. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360039567171-Testing-Events-and-Revenue'>이벤트 및 수익 테스트</a>를 참조하세요.</li>" +
                        "<ul style=\"text-align: left;padding: 10px 0 10px 20px\">" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/categories/360002441132'>개발자 문서</a>에서 언급했듯, 거래 영수증 검증을 위해 구매 객체를 전달하는 것을 권장합니다. 유효한 수익만 보고서에 반영됩니다.</li>" +
                        "<li><strong>영수증 검증에 관한 질문이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href=''>인앱 구매 검증 FAQ</a>를 참조하세요.</li>" +
                        "</ul>" +
                        "<li><strong>커스텀 사용자 ID:</strong> 통합에 사용자 식별을 추가하면, 여러 기기에서 사용자를 추적하거나 Apple/Google 광고 ID가 차단된 경우에도 유용합니다. 테스트 시, 모든 이벤트에 커스텀 사용자 ID가 파라미터로 표시되는지 확인하세요.</li>" +
                        "</ol>",
                    "PARTNER_CONFIGURATION": "Singular는 두 종류의 데이터를 보고합니다 - 네트워크에서 가져온 데이터와 Singular의 어트리뷰션 서비스 데이터. SDK를 통합할 때 어트리뷰션 서비스를 설정했습니다. " +
                        "이번 단계에서는 각 광고 파트너별 어트리뷰션 설정을 하여 Singular가 데이터를 보고할 수 있도록 합니다. 이는 <strong>어트리뷰션 설정 > 파트너 구성</strong>에서 진행합니다.<br/>" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://www.singular.net/glossary/self-attributing-network/#:~:text=How%20Singular%20works%20with%20self,%2C%20Snapchat%2C%20and%20Yahoo%20Gemini.'>자체 기여 네트워크</a>에 필수입니다. 좌측 네비게이션에서 Facebook과 Google Adwords 섹션을 참고하세요.<br /><br />" +
                        "<strong>설정 방법:</strong>" +
                        "<ol><li><strong>어트리뷰션 설정 > 파트너 구성</strong>으로 이동하여 파트너를 선택합니다.</li>" +
                        "<li>앱 사이트별로 어트리뷰션 설정을 구성해야 합니다. 예:" +
                        "<ol>" +
                        "<li>파트너에 전송할 이벤트는 무엇인가요? <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360036736891-Defining-In-App-Events'>이벤트 선택 팁 보기</a>.</li>" +
                        "<li>재참여 캠페인을 진행 중인가요?</li>" +
                        "<li>노출(impressions) 또는 클릭(clicks)으로만 어트리뷰션 하시겠습니까?</li>" +
                        "</ol></li></ol>" +
                        "추가 지원이 필요하시면 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/115000483946-Partner-Configuration'>파트너 구성 가이드</a>를 참고하세요.<br/>" +
                        "특정 파트너 관련 질문은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/categories/201687706-Attribution-and-Singular-Links#Partner%20Integrations%20in%20Detail'>파트너 통합 가이드</a>를 참조하세요.",
                    "GET_STARTED_FACEBOOK": "Singular가 설치 및 이벤트를 추적할 수 있도록 <strong>파트너 구성</strong>에서 Facebook을 설정하세요.<br/><br/>" +
                        "Facebook의 경우 이 설정만으로 충분하며, 별도의 트래킹 링크를 만들 필요가 없습니다.<br/><br/>" +
                        "<strong>Facebook 설정 방법:</strong>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://www.facebook.com/ads/manage/advanced_mobile_measurement/app_based_tos'>Facebook 고급 모바일 측정 계약</a>에 서명했는지 확인하세요. 없으면 Singular가 클릭 단위 통계 공유를 할 수 없습니다.</li>" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://developers.facebook.com/apps'>Facebook 앱 대시보드</a>에서 Facebook 앱 ID를 가져와 Singular의 <strong>파트너 구성</strong>에 입력하세요.</li>" +
                        "<li>어트리뷰션 설정을 구성합니다. 조회 추적(view-through tracking)을 활성화/비활성화하거나 어트리뷰션 기간을 변경할 수 있습니다.<br/>" +
                        "기본 설정을 변경하면 Singular와 Facebook 대시보드 간 설치 수 차이가 발생할 수 있습니다.</li>" +
                        "<li>이벤트 포스트백을 Facebook으로 전송하도록 활성화하세요. 특정 이벤트 최적화에 적합합니다 (<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://developers.facebook.com/docs/app-ads/optimizing-your-app-ad'>자세히 보기</a>).</li>" +
                        "<li>Facebook SKAdNetwork 캠페인을 진행하려면 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360055071772'>Facebook SKAdNetwork 통합 가이드</a>를 참고하세요.</li>" +
                        "</ol><br/>" +
                        "<strong>질문이 있으신가요?</strong> Facebook 설정 가이드와 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360038261212'>문제 해결 가이드</a>를 참조하세요.",

                    "GET_STARTED_ADWORDS": "Singular가 설치 및 이벤트를 추적할 수 있도록 <strong>파트너 구성</strong>에서 Google Ads를 설정하세요.<br/><br/>" +
                        "Google Ads의 경우 이 설정만으로 충분하며, 별도의 트래킹 링크를 만들 필요가 없습니다.<br/><br/>" +
                        "<strong>Google Ads 설정 방법:</strong><br/>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li><strong>링크 ID 입력:</strong> Google Ads 계정에서 링크 ID를 생성하세요 (자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.google.com/google-ads/answer/7365001?hl=en'>Google 안내</a> 참조). Singular의 <strong>파트너 구성</strong>에서 생성한 링크 ID를 입력하세요.</li>" +
                        "<li>일반적인 어트리뷰션 설정을 구성하세요.</li>" +
                        "<li><strong>이벤트 가져오기:</strong> 전환 및 이벤트 추적을 시작하려면 Google Ads 계정에서 전환 작업을 설정하세요. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360052936331'>Google Ads 어트리뷰션 통합: 이벤트 가져오기</a>를 참조하세요.<br/>" +
                        "설정 후 최소 한 번의 전환 이벤트가 발생해야 Singular 이벤트가 Google Ads에 표시됩니다.</li>" +
                        "<li><strong>이벤트 전송:</strong> 캠페인 최적화를 위해 Singular가 인앱 이벤트에 대한 Google Ads 포스트백을 전송하도록 허용하세요. 이벤트를 Google 이벤트와 매핑하거나 \"custom\"으로 둘 수 있습니다.</li>" +
                        "</ol><strong>질문이 있으신가요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/115003252786-Google-Ads-AdWords-'>Google Ads 가이드</a>를 참고하세요.",
                    "DATA_CONNECTORS": "Singular는 두 종류의 데이터를 보고합니다 - 네트워크에서 가져온 데이터와 Singular의 어트리뷰션 서비스 데이터. 이번 단계에서는 각 광고 파트너별로 네트워크 데이터를 받기 위해 데이터 커넥터를 설정합니다. " +
                        "이 작업은 <strong>데이터 통합 > 데이터 커넥터</strong>에서 진행합니다.<br/><br/>" +
                        "<strong>설정 방법:</strong><br/>" +
                        "<ol>" +
                        "<li><strong>데이터 통합 > 데이터 커넥터</strong>로 이동하세요.</li>" +
                        "<li>새 데이터 커넥터를 클릭한 후, 검색창에 네트워크 파트너를 찾으세요.</li>" +
                        "<li>팝업되는 파트너 구성 패널에서 필요한 정보를 입력하세요(보통 API 키와 사용자 이름). " +
                        "패널에서 파트너 대시보드 내 정보 위치를 안내합니다.</li>" +
                        "<li>Facebook과 Google Adwords의 경우 관련 권한이 있는 Facebook/Google 계정으로 로그인해야 할 수 있습니다.</li>" +
                        "</ol><br/><br />" +
                        "추가 도움이 필요하면 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360031000051'>데이터 커넥터 FAQ</a>를 참고하세요.",
                    "SET_UP_FACEBOOK":
                        "<p>Meta Ads / Facebook은 자체 어트리뷰팅 네트워크입니다. 따라서 트래킹 링크를 생성할 필요가 없습니다. 대신 아래 단계를 따라 시작하세요.</p>" +
                        "<ol>" +
                        "<li><strong>데이터 커넥터 추가</strong> - Singular가 Facebook 보고 API를 호출하여 비용 및 네트워크 통계를 가져옵니다.</li>" +
                        "<li><strong>파트너 구성 추가</strong> - <a href='https://developers.facebook.com/apps' target='_blank'><u>Facebook 개발자 대시보드</u></a>에서 Facebook 앱 ID를 가져오세요.\n</li>" +
                        "<ol style=\"list-style-type:lower-alpha\">" +
                        "<li>여기서 포스트 설치 이벤트(캠페인 최적화를 위해 Facebook Ads에 전송할 이벤트)를 추가하라는 요청을 받습니다.\n</li>" +
                        "<li>클릭 어트리뷰션 기간 같은 추가 설정도 할 수 있습니다. Facebook 대시보드의 설정과 일치하도록 꼭 확인하세요.</li>" +
                        "</ol>" +
                        "<li><strong><a href='https://support.singular.net/hc/ko/articles/360055071772-Facebook-Ads-SKAdNetwork-Integration#4_Import_Conversion_Model_in_Facebook_Event_Manager' target='_blank'><u>SKAN 캠페인의 경우</u></a></strong> - 다음 단계를 수행해야 합니다:</li>" +
                        "<ol style=\"list-style-type:lower-alpha\">" +
                        "<li><a href='https://app.singular.net/#/react/skadnetwork' target='_blank'><u>Singular에서 전환 모델 설정</u></a>. SKAN 모델에 사용하는 이벤트가 파트너 구성에도 설정되어 있어야 합니다.</li>" +
                        "<li><a href='https://www.facebook.com/events_manager' target='_blank'><u>Facebook 이벤트 관리자</u></a> 대시보드로 이동하여 SKAdNetwork 이벤트 구성을 엽니다.</li>" +
                        "<li>설정 > 이벤트 설정을 선택하세요.</li>" +
                        "<li>파트너 앱에서 가져오기를 선택하세요. 다음 화면에서 Facebook이 MMP URL 입력을 요청합니다. 다음 URL을 만들고 app_id 파라미터에 앱의 앱스토어 ID를 입력하세요:</li>" +
                        "<li>다음 화면에서 Facebook이 MMP URL 입력을 요청합니다. 다음 URL을 만들고 app_id 파라미터에 앱의 앱스토어 ID를 입력하세요:</li>" +
                        "<code class='codeBlock'>http://api.singular.net/api/skadnetwork/conversion_info?org_type=partner&app_id=[your_app_id]</code>" +
                        "</ol>" +
                        "<li><strong><a href='https://support.singular.net/hc/ko/articles/115003252706-Facebook-Meta-Ads-Attribution-Integration#iOS_Aggregated_Event_Measurement_FAQ' target='_blank'><u>AEM 캠페인의 경우</u></a></strong> - 추가 설정이 필요하지 않습니다. 트래커 설치 내에서 AEM 귀속 설치를 추적하려면 파트너 구성에서 Advanced AEM에 옵트인하세요. 자세한 내용은 <a href='https://support.singular.net/hc/ko/articles/115003252706-Facebook-Meta-Ads-Attribution-Integration#whatisaem' target='_blank'><u>도움말 센터</u></a>를 참조하세요.</li>" +
                        "<li><strong>안드로이드 캠페인의 경우</strong> - 파트너 구성에서 메타 리퍼러를 반드시 설정해야 합니다. 자세한 내용은 <a href='https://support.singular.net/hc/ko/articles/115003252706#whatismetareferrer' target='_blank'><u>여기</u></a>를 참고하세요.</li>" +
                        "</ol>" +
                        "<li>도움이 필요하시면 <a href='https://support.singular.net/hc/ko/articles/208690176-Facebook-Data-Connector#Add_the_Data_Connector'  target='_blank'><u>도움말 센터 가이드</u></a>를 확인하세요.</li>",
                    "SET_UP_GOOGLE":
                        "<p>Singular에서 AdWords를 설정하려면 데이터 커넥터와 파트너 구성을 추가해야 합니다. 트래킹 링크를 생성할 필요는 없습니다.</p>" +
                        "<strong><p>최적 구성을 위해 아래 단계를 건너뛰지 마세요.</p></strong>" +
                        "파트너 구성 추가 방법:<br/>" +
                        "<ol>" +
                        "<li>Google Ads 링크 ID를 생성하세요. <a href='https://support.google.com/google-ads/answer/7365001?hl=en' target='_blank' title='https://support.google.com/google-ads/answer/7365001?hl=en'><u>(?)</u></a></li>" +
                        "<li>" +
                        "<strong>Attribution</strong> > <strong>Partner Configuration</strong>에서 <strong>Add a Partner</strong>를 클릭하고 &ldquo;AdWords (Google Ads)&rdquo;를 선택하세요." +
                        "</li>" +
                        "<li>Singular가 포스트 설치 이벤트를 전송하도록 구성하세요.</li>" +
                        "<li>도움이 필요하면 <a href='https://support.singular.net/hc/ko/articles/115003252786-Google-Ads-AdWords-Attribution-Integration#How_to_Setup_your_Partner_Configuration' target='_blank' title='https://support.singular.net/hc/ko/articles/115003252786-Google-Ads-AdWords-Attribution-Integration#How_to_Setup_your_Partner_Configuration'><u>도움말 센터 가이드</u></a>를 참고하세요.</li>" +
                        "</ol>" +
                        "데이터 커넥터 추가 방법:<br/>" +
                        "<ol>" +
                        "<li>Google Ads 계정에서 MCC 고객 ID를 가져오세요.</li>" +
                        "<li><strong>Settings</strong> > <strong>Data Connectors</strong>에서 <strong>Add Data Connector</strong>를 클릭하고 &ldquo;AdWords (Google Ads)&rdquo;를 선택하세요.</li>" +
                        "<li>Google 계정으로 로그인하세요.</li>" +
                        "<li>추가한 데이터 커넥터를 열고 MCC 고객 ID를 입력하세요.</li>" +
                        "<li>데이터를 가져올 계정을 활성화하세요.</li>" +
                        "<li>Adwords에서 가져올 전환 이벤트를 구성하세요.</li>" +
                        "<li>도움이 필요하면 <a href='https://support.singular.net/hc/ko/articles/360036750251-Google-Ads-AdWords-Data-Connector' target='_blank' title='https://support.singular.net/hc/ko/articles/360036750251-Google-Ads-AdWords-Data-Connector'><u>도움말 센터 가이드</u></a>를 참고하세요.</li>" +
                        "</ol>",
                    "SET_UP_APPLE_SEARCH_ADS": `
                        <div>
                          <p>Apple Search Ads를 시작하려면 다음 세 가지가 필요합니다:</p>
                          <ol>
                            <li>
                              Singular SDK 통합
                              <ol style="list-style-type: lower-alpha;">
                                <li>
                                  <p>
                                    <strong>AdServices 프레임워크가 포함되어 있는지 확인하세요!</strong>
                                    서버 간 통합(S2S)이 있다면
                                    <a href="https://support.singular.net/hc/ko/articles/360037640812-Server-to-Server-S2S-Integration-Guide" title="https://support.singular.net/hc/ko/articles/360037640812-Server-to-Server-S2S-Integration-Guide">
                                    Apple Search Ads용 S2S 구현 가이드</a>를 사용하여 업데이트하세요.
                                  </p>
                                </li>
                              </ol>
                            </li>
                            <li>
                              <p>
                                <a href="https://app.singular.net/#/react/data-sources?id=1530" title="https://app.singular.net/#/react/data-sources?id=1530">
                                Apple Search Ads <strong>데이터 커넥터</strong>를 추가하세요.
                                </a>
                              </p>
                            </li>
                            <li>
                              <p>
                                <a href="https://app.singular.net/#/react/partner-config?partner=97172" title="https://app.singular.net/#/react/partner-config?partner=97172">
                                <strong>파트너 구성</strong>에서 Apple Search Ads를 설정하세요.
                                </a> Apple은 사용자 이벤트를 수신하지 않으므로 이벤트 구성은 필요 없지만 관련 앱 사이트를 저장하기 전까지 설치 보고가 되지 않습니다.
                              </p>
                            </li>
                          </ol>
                          <p>
                            iOS 14.3부터 Apple Search Ads 캠페인은
                            <a href="https://developer.apple.com/documentation/adservices" title="https://developer.apple.com/documentation/adservices">
                            AdServices 프레임워크</a>를 기반으로 한 새로운 자체 어트리뷰팅 통합을 통해 측정됩니다. Apple은 iAd 프레임워크를 더 이상 지원하지 않습니다.
                          </p>
                          <p>
                            <strong>보고서에서 무엇을 볼 수 있나요?</strong><br/>
                            Apple Search Ads는 SKAdNetwork와 별도로 측정되며, 전통적인 비-SKAdNetwork 보고서와 사용자 수준 내보내기에서만 데이터가 제공됩니다.
                          </p>
                          <p>
                            <strong>도움이 필요하세요?</strong> <a href="https://support.singular.net/hc/ko/articles/115003234483" target="_blank">Apple Search Ads Attribution Integration</a>를 참조하세요.
                          </p>
                        </div>
                      `,
                    "CUSTOM_SOURCES_LINKS": "이메일 캠페인이나 인플루언서 마케팅과 같은 커스텀 소스에 대한 트래킹 링크를 생성할 수 있습니다.<br/>" +
                        "<ol>" +
                        "<li><strong>트래킹 링크 만들기(Build a Tracking Link)</strong> 가이드의 단계를 따르되, 5단계의 <strong>링크 유형(Link Type)</strong>에서 “커스텀 소스(Custom Source)”를 선택하세요.</li>" +
                        "<li><strong>소스 이름(Source Name)</strong>에서 \"Crosspromo\", \"Email\", \"SMS\", \"Social\", 또는 \"Custom\" 중 선택하세요.<br/>" +
                        "여기서 선택한 값은 보고서의 <strong>소스(Source)</strong> 차원에 반영됩니다.</li>" +
                        "</ol><br/>",
                    "EXPORT_DATA": "Singular는 데이터를 데이터 웨어하우스, 저장 서비스, 또는 BI 플랫폼으로 직접 내보낼 수 있습니다. 이후 사용자는 자체 도구를 사용해 데이터를 처리하고 분석할 수 있습니다. " +
                        "Singular는 여러 스키마를 제공합니다. 사용 가능한 스키마는 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360039511492'>집계 데이터 스키마(Aggregated Data Schemas)</a>나 " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360048784092'>사용자 수준 데이터 스키마(User-Level Data Schemas)</a>에서 확인할 수 있습니다.<br/><br/>" +
                        "데이터 대상(destination)을 생성하고 저장하면 다른 스키마로 변경할 수 없습니다. 이는 라이브 데이터베이스의 테이블 구조 변경이 위험하고 복잡하기 때문입니다.<br/><br/>" +
                        "스키마 변경이 필요하면 새 대상을 생성하세요. 기존 테이블을 삭제한 후 새 대상을 만들거나, 새 대상을 다른 이름의 테이블에 데이터 로드하도록 구성할 수 있습니다. " +
                        "이 과정을 통해 데이터 안전이 보장되고 기존 쿼리와 작업 부하가 계속 작동합니다.<br/><br/>" +
                        "더 도움이 필요하면 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360037917571-Singular-Data-Destinations-ETL-FAQ'>Singular 데이터 대상 FAQ</a>를 참고하세요.",
                    "MANAGE_LINKS": "Facebook, Google Adwords, Apple Search Ads 같은 광고 네트워크는 '자체 어트리뷰팅(self-attributing)'입니다. 즉, 어떤 광고가 사용자 설치(또는 노출)를 유도했는지 스스로 판단합니다.<br/><br/>" +
                        "자체 기여 네트워크만 사용한다면 이 단계를 건너뛸 수 있습니다.<br/><br/>" +
                        "다른 광고 네트워크의 경우, 트래킹 링크를 통해 Singular가 동일한 정보를 알 수 있습니다. 또한 이메일이나 SMS 캠페인 같은 커스텀 소스에도 트래킹 링크가 도움이 됩니다.<br/><br/>" +
                        "Singular 내에서 트래킹 링크를 생성하고, 예를 들어 \"gamesco.sng.link\"와 같이 회사명을 포함해 맞춤 설정할 수 있습니다. 링크는 사용자의 디바이스 플랫폼, 광고 크리에이티브 자산 등 매개변수를 포함할 수 있어 보고서의 가치를 높입니다.<br/><br/>" +
                        "<strong>사용법:</strong>" +
                        "<ol>" +
                        "<li>6단계에서 설명한 대로 광고 네트워크 파트너를 설정했는지 확인하세요.</li>" +
                        "<li><strong>어트리뷰션 설정 > 링크 관리</strong>로 이동하세요.</li>" +
                        "<li><strong>링크 도메인 관리(Manage Link Domains)</strong>를 클릭하고 새 서브도메인을 생성하세요.</li>" +
                        "<li>앱을 선택한 후 <strong>링크 생성(Create Link)</strong>을 클릭하세요.</li>" +
                        "<li><strong>링크 유형(Link Type)</strong>에서 \"파트너(Partner)\"를 선택하세요.</li>" +
                        "<li><strong>소스 이름(Source Name)</strong>에서 네트워크를 선택하고, <strong>트래킹 링크 이름(Tracking Link Name)</strong>을 지정하세요.</li>" +
                        "<li>링크 설정 및 리디렉션 섹션에서 <strong>링크 서브도메인(Link Sub-Domain)</strong>을 선택하세요.</li>" +
                        "<li>네트워크 파트너가 Android와 iOS 트래킹을 지원하면 활성화할 수 있습니다. 앱용 적절한 사이트를 선택하고 일반적으로 스토어 URL 같은 시청자 리디렉션 링크를 제공하세요.</li>" +
                        "<li><strong>기타 플랫폼용</strong> 백업 목적지 URL을 제공하고, <strong>생성(Generate)</strong> 버튼을 클릭해 트래킹 링크를 만드세요.</li>" +
                        "</ol><br/>" +
                        "더 도움이 필요하면 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360030934212-Singular-Links-FAQ'>Singular 링크 FAQ</a>를 참고하세요.",
                    "CUSTOM_SOURCES": "완벽한 마케팅 계획에는 이메일 및 문자메시지 캠페인, 크로스 프로모션(여러 앱 간), 그리고 소셜 미디어 인플루언서 마케팅이 포함됩니다.<br/><br/>" +
                        "Singular는 “<strong>커스텀 소스(custom sources)</strong>”를 위한 트래킹 링크 설정으로 이러한 활동을 추적할 수 있습니다.<br/><br/>" +
                        "커스텀 소스란 미리 설정된 네트워크 파트너가 아닌 모든 채널을 의미합니다.<br/><br/>" +
                        "<strong>커스텀 소스 시작하기:</strong>" +
                        "<ul>" +
                        "<li>보고서에 표시될 소스 이름을 지정하세요.</li>" +
                        "<li>트래킹 링크에 캠페인 이름 등의 추가 매개변수를 전달하면 보고서에 캠페인 수준 세부 정보가 반영됩니다. <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360018879491-Tracking-link-parameters-and-report-dimensions'>전체 트래킹 링크 보고 매개변수 목록</a>을 참고하세요.</li>" +
                        "<li>CPI 테이블을 추가해 커스텀 소스에 대한 비용 보고도 설정할 수 있습니다. <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/206409915-CPI-Configuration-FAQ'>FAQ</a>를 확인하세요.</li>" +
                        "</ul>",
                    "TEST_LINKS": "트래킹 링크를 <strong>링크 관리</strong> 페이지에서 생성했습니다. 캠페인에 사용하기 전에 클릭해 모바일 기기에 앱을 설치하여 링크를 테스트할 수 있습니다. 이를 통해 Singular가 수신하는 정보를 확인할 수 있습니다.<br/><br/>" +
                        "<strong>시작 전 확인 사항:</strong>" +
                        "<ul>" +
                        "<li>네트워크가 수동 테스트를 허용하는지 확인하세요. 일부 네트워크는 지리적 위치에 따라 클릭을 차단합니다.</li>" +
                        "<li>Singular에 아직 추적되지 않은 깨끗한 디바이스(기기 ID) 또는 기기 ID 초기화 방법에 따라 디바이스를 준비하세요.</li>" +
                        "<li><strong>로그 내보내기</strong>에서 클릭과 설치가 정상적으로 발생했는지 확인하세요.</li>" +
                        "<li>또는 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360045803392-How-to-Verify-Device-Attribution#How_to_Verify_Attribution_Using_the_Attribution_Details_Endpoint'>Attribution Details API</a>를 사용해 테스트 성공 여부를 확인할 수 있습니다.</li>" +
                        "</ul><br/>" +
                        "<strong>질문이 있으신가요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360046951332-How-to-Test-a-Tracking-Link'>트래킹 링크 테스트 방법</a>를 참고하세요.",
                    "DEEP_LINKING": "기존 사용자를 앱 내 특정 위치로 안내하려면 트래킹 링크를 '딥링크(deep link)'로 구성할 수 있습니다. 이는 리인게이지먼트 및 리타겟팅 캠페인에 사용됩니다.<br/><br/>" +
                        "딥링크를 통해 사용자가 이미 앱을 설치한 상태에서 광고를 클릭하면 앱이 열릴 뿐 아니라 기본 화면이 아닌 특정 앱 콘텐츠가 표시됩니다.<br/><br/>" +
                        "팁:" +
                        "<ul>" +
                        "<li>\"Android 앱 링크 인증서 또는 팀 ID를 설정해야 한다\"는 메시지가 나오면 <strong>앱</strong> 페이지에서 딥링크 설정이 올바르게 되어 있지 않은 것입니다.</li>" +
                        "<li>설정을 테스트하려면 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360046951332-How-to-Test-a-Tracking-Link#How_to_Test_Deep_Linking'>딥링크 테스트 방법</a>을 참고하세요.</li>" +
                        "</ul><br/>" +
                        "<strong>종류:</strong>" +
                        "<ul>" +
                        "<li><strong>지연된 딥링크(deferred deep links)</strong>는 앱이 설치되어 있지 않은 사용자에게도 앱 내 특정 페이지나 콘텐츠로 연결하는 딥링크입니다. <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360031370991-Deep-Linking-FAQ?navigation_side_bar=true#what_are_deferred_deep_links'>자세히 보기</a>.</li>" +
                        "<li><strong>iOS 유니버설 링크(Universal Links)</strong>와 <strong>안드로이드 앱 링크(Android App Links)</strong>는 OS별 딥링크로, 과거 설정이나 가용성에 따라 앱 내 특정 위치 또는 웹사이트 특정 페이지로 사용자를 안내합니다. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360030934212-Singular-Links-Tracking-Links-FAQ#Deep_Linking_Terms_and_Concepts_iOS_Universal_Links'>딥링크 FAQ</a>를 참고하세요.</li>" +
                        "</ul><br/>",
                    "RUN_REPORT": "Singular 내에서 여러 보고서를 이용할 수 있습니다.<br/>" +
                        "<ol>" +
                        "<li><strong>대시보드</strong> - 아래에 설명된 다른 모든 보고서의 데이터를 시각화할 맞춤형 대시보드를 만듭니다. " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/206241026'>대시보드 FAQ 및 문제 해결</a></li>" +
                        "<li><strong>보고서 및 통계 > 보고서</strong> - 일반 광고 캠페인에 대한 집계 보고서를 조회합니다. " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/205046069-Reports-FAQ-and-Troubleshooting'>보고서 FAQ 및 문제 해결</a></li>" +
                        "<li><strong>보고서 및 통계 > 크리에이티브</strong> - 크리에이티브 자산의 성과 보고서를 조회합니다. " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/115001862443-Creative-Reports-FAQ-and-Troubleshooting'>크리에이티브 보고서 FAQ</a></li>" +
                        "<li><strong>SKAdnetwork > 로우 데이터</strong> - SKAdNetwork 캠페인(iOS 14.3 이상)의 원시 데이터를 확인합니다. " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/4408240139163-SKAdNetwork-Raw-Data-FAQ-and-Troubleshooting'>SKAN 원시 데이터 FAQ</a></li>" +
                        "<li><strong>SKAdnetwork > 보고서</strong> - SKAdNetwork 캠페인에 대한 집계 보고서를 확인합니다. " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/4408232000795-SKAdNetwork-Reports-FAQ-and-Troubleshooting'>SKAN 보고서 FAQ</a></li>" +
                        "<li><strong>보고서 및 통계 > 광고 수익화</strong> - 광고 수익화 활동에 대한 집계 보고서를 확인합니다. " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360022067552-Setting-Up-Ad-Monetization-Reporting'>광고 수익화 분석 FAQ</a></li>" +
                        "<li><strong>사기 방지</strong> - 거부되거나 의심스러운 설치 및 Singular가 사기 시도로부터 보호한 사례에 대한 보고서를 확인합니다. " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360003121852-Fraud-Reports-and-Fraud-Logs-FAQ-and-Troubleshooting'>사기 보고서 및 로그 FAQ</a></li>" +
                        "</ol>" +
                        "이 보고서들 외에도 <strong>보고서 및 통계 > 로그 내보내기</strong>에서 캠페인 원시 데이터를 얻을 수 있습니다.<br/>" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360001216992-Export-Logs-and-User-Level-Data-FAQ'>내보내기 로그 FAQ</a>.",
                    "VISUALIZE_CAMPAIGNS": "Singular 대시보드는 쉽고 유연한 데이터 시각화 도구를 통해 데이터를 최대한 활용할 수 있게 도와줍니다.<br/><br/>" +
                        "<ul>" +
                        "<li><strong>대시보드 경험 시작하기</strong> - 조직의 사전 설정된 대시보드를 방문하여 즉시 데이터를 활용하세요. <a href='#/react/dashboard?default=true'>사전 설정된 대시보드 방문</a></li>" +
                        "<li><strong>대시보드 맞춤화</strong> - 여러 개의 대시보드를 생성하고, 막대 차트, 원형 차트, 표 등 다양한 위젯과 데이터 유형(보고서, SKAdNetwork, 크리에이티브 등)으로 데이터를 시각화할 수 있습니다. <a href='#/react/dashboard?new=true'>새 대시보드 만들기</a></li>" +
                        "<li><strong>대시보드 레이아웃 개인화</strong> - 유연한 그리드에서 위젯을 드래그 앤 드롭하거나 크기를 조절하여 원하는 레이아웃을 구성하세요.</li>" +
                        "</ul><br/>" +
                        "<strong>궁금한 점이 있으신가요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/206241026-Dashboard-FAQ-and-Troubleshooting'>대시보드 FAQ 및 문제 해결</a>에서 자세히 알아보세요.",
                    "COHORTED_EVENTS": "<p>" +
                        "구매, 레벨업, 회원가입 등은 Singular가 귀하의 앱이나 웹사이트 내에서 추적할 수 있는 사용자 이벤트의 예입니다.<br/>" +
                        "적절한 인앱 이벤트를 추적함으로써 조직의 마케팅 성과를 중요한 KPI를 통해 측정할 수 있습니다." +
                        "</p><br/>" +
                        "<p>" +
                        "Singular SDK를 통해 미리 정의된 이름이 있는 표준 이벤트를 사용 중이라면, 이 이벤트들은 <strong>자동으로 생성되어</strong> <strong>이벤트</strong> 페이지에 나타납니다. " +
                        "이로써 온보딩 시 시간을 절약할 수 있습니다.<br/>" +
                        "가능하면 표준 이벤트 사용을 권장합니다.<br/>" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/7648172966299'>시작하는 데 도움이 되도록, 수직별로 자주 사용하는 이벤트 목록과 추천 속성을 정리했습니다.</a>" +
                        "</p><br/>" +
                        "추가 커스텀 이벤트는 여전히 이벤트 페이지에서 수동으로 추가해야 합니다. 커스텀 이벤트 생성 방법:" +
                        "<ol>" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://app.singular.net/#/react/singular-events'>설정 > 이벤트</a>로 가서 <strong>코호트 이벤트</strong> 탭에 머무르세요.</li>" +
                        "<li>이벤트가 전역(Global, 모든 앱에 적용)인지 앱별(App-Specific)인지 선택하세요.</li>" +
                        "<li><strong>새 이벤트</strong> 버튼을 클릭하고 이벤트 이름(예: “가입”)을 지정하세요.</li>" +
                        "<li>이벤트를 사용자별로 한 번만 집계할지 여부를 토글하세요.</li>" +
                        "<li>아래 파트너 목록에서 관련 파트너(예: “Singular”)를 찾아, 집계하려는 파트너가 전송하는 이벤트(예: 모든 앱의 “가입 수” 버전)를 선택하세요.</li>" +
                        "<li>다른 설정을 구성하고 이벤트를 저장하세요.</li>" +
                        "</ol><br/>" +
                        "<strong>질문이 있으신가요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/208385833'>이벤트 FAQ</a>를 확인하세요.",
                    "REPORTS_AND_PIVOTS": "캠페인이 라이브 상태가 되면, 보고서를 실행할 준비가 된 것입니다!<br/><br/>" +
                        "<strong>보고서 실행 관련 몇 가지 팁:</strong>" +
                        "<ul>" +
                        "<li>특정 네트워크에서 일부 데이터가 N/A로 표시되는 이유를 이해하려면 언제든지 도움말 센터에서 네트워크 세부 정보를 확인하세요. <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/categories/360000139492-Singular-Analytics#Data Connectors in Detail'>데이터 커넥터 상세 정보</a></li>" +
                        "<li><strong>보고서 저장하기:</strong> 동일한 보고서를 다시 정의하지 않고도 실행할 수 있게 합니다. <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/218104323-Bookmarking-a-Report'>보고서 저장에 대해 더 알아보기</a></li>" +
                        "<li><strong>보고서 공유하기</strong> - Singular 계정에 가입하지 않은 사용자(대행사나 네트워크 등)와도 보고서를 공유할 수 있습니다. <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360046877232-Shared-Reports-FAQ'>공유 보고서 FAQ</a> 참조</li>" +
                        "<li><strong>매핑되지 않은 데이터:</strong> 네트워크가 번들 ID나 사이트 공개 ID별로 데이터를 제공하지 않을 경우, Singular가 관련 앱에 매핑할 수 없습니다. 이 데이터는 보고서에서 N/A로 표시됩니다. <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360031705411-Unmapped-Data-FAQ'>매핑되지 않은 데이터 FAQ</a> 참조</li>" +
                        "<li>계산된 지표를 설정하려면 Singular 지원팀에 문의하세요.</li>" +
                        "</ul><br/>" +
                        "<strong>궁금한 점이 있으신가요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/205046069-Reports-FAQ-and-Troubleshooting?'>보고서 FAQ 및 문제 해결 문서</a>를 참고하세요.",
                    "ADVANCED_REPORTING": "더 높은 단계로 도약할 준비가 되셨나요? 보고서를 맞춤화하는 데 도움이 되는 고급 보고 기능들을 확인해 보세요." +
                        "<ul>" +
                        "<li><strong>비교 보고서:</strong> 단일 기간 선택 대신 “2개 기간 비교”를 선택하여 마케팅 활동의 증감 변화를 자동으로 강조 표시할 수 있습니다.</li>" +
                        "<li><strong>사용자 정의 차원:</strong> 새로운 차원을 정의하여 보고서를 필요에 맞게 맞춤 설정하세요. 예를 들어, 가능한 값이 \"소셜\", \"검색\", \"디스플레이\", \"리타게팅\"인 “채널” 차원을 만들거나, 팀원 이름이 값인 “UA 매니저” 차원을 만들 수 있습니다. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/208578986'>사용자 정의 차원 FAQ</a>를 참고하세요.</li>" +
                        "<li><strong>캠페인 속성:</strong> 캠페인 입찰가 변경이 성과에 미친 영향을 측정합니다. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360032548672'>캠페인 속성 FAQ</a>를 참고하세요.</li>" +
                        "<li><strong>캠페인의 큰 변화나 중요한 시점에 대해 데이터 알림을 설정하여 자동으로 통보받으세요.</strong> 알림은 캠페인, 트래커 또는 광고 수익화 데이터에 대해 설정할 수 있습니다. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/207429293--UPDATED-Alerts-FAQ-and-Troubleshooting'>알림 FAQ</a>를 참고하세요.</li>" +
                        "</ul><br/>" +
                        "<strong>새 기능 소식을 받아보려면</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360061042971-Product-Updates'>제품 업데이트</a>에 등록하세요.",
                    "RUN_ADDITIONAL_REPORT": "Singular 플랫폼에서 사용할 수 있는 추가 보고서에 대한 간단한 개요입니다:" +
                        "<ul>" +
                        "<li><strong>대시보드:</strong> 대시보드에서 전체 마케팅 성과를 확인하세요. 지표 편집을 통해 대시보드를 맞춤화할 수 있습니다. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/206241026-Dashboard-FAQ'>대시보드 FAQ</a>를 참고하세요.</li>" +
                        "<li><strong>리텐션 히트맵:</strong> 마케팅 채널 전반의 리텐션을 빠르게 검토하려면 리텐션 보고서로 이동하세요. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/208156336-Retention-FAQ'>리텐션 FAQ</a>를 참고하세요.</li>" +
                        "<li><strong>목표:</strong> 진행 상황을 모니터링하세요! 예산을 추적하는 목표를 설정하고, 보고서를 실행해 목표 달성 시점에 맞게 예산 배분이 적절한지 확인하세요. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/206975446-Goal-Management-FAQ'>목표 FAQ</a>를 참고하세요.</li>" +
                        "<li><strong>내보내기 로그:</strong> 캠페인을 테스트 실행하거나 클릭 레벨 및 사용자 레벨 데이터를 확인하려면 내보내기 로그를 사용하세요. Singular SDK가 기록한 모든 클릭, 세션, 설치 내역을 검토할 수 있습니다. 팁: 보고서를 실행할 때 가능한 한 많은 필터를 사용하면 데이터를 더 쉽게 반환받을 수 있습니다. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360001216992-Exporting-Attribution-Logs'>내보내기 로그 및 사용자 레벨 데이터 FAQ</a>를 참고하세요.</li>" +
                        "</ul>",
                    "EXPLORE_OTHER_WAYS": "Singular는 데이터를 추출할 수 있는 다양한 프로그래밍 방식 솔루션을 제공합니다.<br/><br/>" +
                        "예를 들어, 보고 API는 보고서나 크리에이티브 페이지에서 볼 수 있는 동일한 데이터를 제공합니다.<br/><br/>" +
                        "또한 내부 BI 플랫폼으로 설치 및 인앱 이벤트에 대한 자동 알림을 받도록 내부 BI 포스트백을 설정할 수도 있습니다.",
                    "REPORTING_API": "Singular 보고 API를 통해 보고서 및 크리에이티브 보고서 페이지에서 볼 수 있는 모든 데이터에 접근할 수 있습니다.<br/><br/>" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://app.singular.net/#/react/testing-console'>Singular API 콘솔</a>에서 API 키를 발급받고, <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/207553433-Guide-to-the-Singular-Reporting-API'>보고 API 시작하기 가이드</a>를 참고하세요.<br/><br/>" +
                        "<strong>팁:</strong>" +
                        "<ul>" +
                        "<li>데이터를 신속히 받으려면 하루 단위로 쿼리를 실행하고, 한 번에 반환되는 데이터를 줄이기 위해 가능한 한 많은 필터를 추가하세요.</li>" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/207553433-Guide-to-the-Singular-Reporting-API'>데이터 가용성</a> 엔드포인트를 사용해 특정 날짜에 각 데이터 소스의 데이터가 있는지 확인할 수 있습니다. 이 결과는 실제 보고서를 실행할 시점을 결정하는 데 도움이 됩니다.</li>" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/203389179-Metrics-and-Dimensions'>메트릭 및 차원 용어집</a>에서 Singular 필드명과 의미를 익히세요.</li>" +
                        "</ul><br/>" +
                        "<strong>궁금한 점이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360045245692-Reporting-API-Reference'>보고 API 참고 문서</a> 또는 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360045245692-Reporting-API-Reference'>FAQ</a>에서 답변을 찾으세요.",
                    "BI_POSTBACKS": "Singular의 어트리뷰션 서비스는 마케팅 성과를 추적하고 측정하는 동안 광고 네트워크의 자체 측정을 위해 설치 및 이벤트를 보고하기 위해 포스트백을 사용합니다.<br/><br/>" +
                        "내부 BI 플랫폼으로 포스트백을 전송하도록 구성할 수도 있습니다. <strong>파트너 구성</strong> 페이지에서 “내부 BI”를 찾아 각 앱별로 원하는 엔드포인트로 포스트백을 보내도록 설정하세요.<br/><br/>" +
                        "<strong>궁금한 점이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://developers.singular.net/docs/partner-postbacks'>내부 BI 포스트백 가이드</a>를 참고하세요.",
                    "ETL": "Singular는 데이터를 직접 데이터 웨어하우스, 스토리지 서비스 또는 BI 플랫폼으로 내보낼 수 있어, 자체 BI 및 시각화 도구를 사용해 데이터를 처리하고 분석할 수 있습니다.<br/><br/>" +
                        "<strong>팁:</strong>" +
                        "<ul>" +
                        "<li>스키마 목록에서 선택하세요. 사용 가능한 스키마는 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360039511492'>집계 데이터 스키마</a> 또는 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360048784092'>사용자 수준 데이터 스키마</a>에서 확인할 수 있습니다.</li>" +
                        "<li>데이터 대상(destination)을 생성하고 저장하면 다른 데이터 스키마로 변경할 수 없습니다. 기존 데이터가 있는 실시간 데이터베이스에서 테이블 구조를 변경하는 것은 위험과 복잡함이 따르기 때문입니다. 스키마 변경이 필요하면 새 대상을 생성하세요. 새 대상을 생성하기 전에 기존 테이블을 삭제하거나, 새 대상이 다른 이름의 새 테이블에 데이터를 적재하도록 설정할 수 있습니다. 이 과정을 통해 데이터 안전성이 보장되고 기존 쿼리 및 작업이 계속 정상 작동합니다.</li>" +
                        "</ul><br/>" +
                        "<strong>궁금한 점이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360037917571-Singular-Data-Destinations-ETL-FAQ'>Singular 데이터 대상 FAQ</a>를 참고하세요.",
                    "SKAN_INTRO": "iOS 14 출시 이후 많은 변화가 있었습니다. 최신 정보를 원하시면 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360047448611-Introduction-to-Singular-s-SKAdNetwork-Solution'>SKAN 소개</a> 및 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360049031852#Is_probabilistic_matching_going_away'>iOS 14 대응 FAQ</a>를 확인하세요.<br/><br/>" +
                        "준비가 되셨다면 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/4403415921805-How-to-Get-Started-with-SKAdNetwork'>SKAdNetwork 시작하기</a>를 참고하세요.<br/><br/>" +
                        "<strong>첫 단계:</strong>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li>최신 SKAN 지원 개선사항을 활용하려면 SDK를 최신 버전으로 업그레이드하세요. 최신 버전은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/categories/360002441132-Singular-SDK-and-S2S#Singular iOS SDK'>iOS SDK</a>, " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/categories/360002441132-Singular-SDK-and-S2S#Singular Unity SDK'>Unity SDK</a>, " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/categories/360002441132-Singular-SDK-and-S2S#Singular React Native SDK'>React Native SDK</a>, " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/categories/360002441132-Singular-SDK-and-S2S#Singular Unreal Engine SDK'>Unreal Engine SDK</a>에서 확인할 수 있습니다.</li>" +
                        "<li>Singular 초기화 전에 앱이 SKAdNetwork를 활성화하도록 코드를 추가하세요. 자세한 내용은 해당 SDK 문서를 참고하세요.</li>" +
                        "<li><a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360057307152'>SKAdNetwork 파트너 목록</a>을 검토하여 특별 요구사항이나 제한사항이 있는지 확인하세요.</li>" +
                        "</ol><br/>" +
                        "<strong>궁금한 점이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/4403415921805-How-to-Get-Started-with-SKAdNetwork'>시작 가이드</a>에서 자세한 안내를 확인할 수 있습니다.",
                    "SKAN_FACEBOOK": "Facebook 캠페인을 생성할 때 광고 전달 최적화를 위한 다양한 옵션을 선택할 수 있습니다.<br/><br/>" +
                        "각 캠페인은 서로 다른 앱 신호를 최적화하므로, 모든 캠페인 유형이 Singular 전환 모델에서 지원되는 것은 아닙니다.<br/><br/>" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360055071772#facebook_campaign_types'>캠페인 유형 및 지원 전환 모델 확인하기</a>.<br/><br/>" +
                        "SKAdNetwork에 Singular 전환 모델을 사용하는 경우, 전환 모델에 정의된 모든 이벤트가 <strong>파트너 구성</strong> 페이지에서 Facebook 이벤트에 매핑되어 있는지 확인하세요. 매핑되지 않은 이벤트는 Facebook 캠페인 최적화나 보고서에 나타나지 않습니다.<br/><br/>" +
                        "<strong>궁금한 점이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360055071772-Facebook-Ads-SKAdNetwork-Integration#Setup_Instructions'>Facebook SKAN 통합 가이드</a>를 참고하세요.",
                    "SKAN_ADWORDS": "Google Ads 데이터 커넥터가 구성되어 있으면 별도의 특별한 설정 없이 사용할 수 있습니다.<br/><br/>" +
                        "다른 네트워크와 달리 Google Ads는 SKAdNetwork 포스트백을 Singular로 직접 전달하지 않고, 전용 API를 통해 데이터를 제공합니다.<br/><br/>" +
                        "Google API 제한으로 인해 일부 데이터는 제공되지 않습니다:" +
                        "<ul>" +
                        "<li><strong>재다운로드 차원은 제공되지 않습니다.</strong> (SKAdNetwork 설치가 새 다운로드인지 재다운로드인지 데이터가 없습니다.)</li>" +
                        "<li><strong>뷰 스루 차원도 제공되지 않습니다.</strong> (설치가 클릭이 아닌 뷰에 의해 귀속되었는지 데이터가 없습니다.)</li>" +
                        "<li><strong>국가 데이터가 제공되지 않습니다.</strong></li>" +
                        "</ul><br/>" +
                        "<strong>궁금한 점이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360062415011--NEW-Google-Ads-SKAdNetwork-Integration'>Google Ads SKAN 통합 가이드</a>를 참고하세요.",
                    "SKAN_CONVERSION_MODEL": "<strong>참고:</strong> SKAN은 iOS에만 해당됩니다.<br/><br/>" +
                        "SKAdNetwork를 통해 사용자 활동을 추적할 때, 앱 설치 후 일정 시간에 앱에서 광고 네트워크로 전송되는 0부터 63 사이의 단일 숫자인 <strong>전환 값</strong>에 의존합니다.<br/><br/>" +
                        "<strong>전환 모델</strong>은 제한된 공간의 전환 값에 설치 후 활동 정보를 최대한 인코딩하는 방법입니다. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360052605611-SKAdNetwork-Model-Configuration-FAQ#General_Concepts_and_Planning'>SKAdNetwork 모델 구성: 일반 개념 및 계획</a>을 참고하세요.<br/><br/>" +
                        "선택한 전환 모델은 캠페인 보고서와 최적화 노력에 영향을 줍니다. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/categories/360004944071-iOS-14-and-SKAdNetwork#SKAdNetwork%20Partner%20Integrations'>SKAdNetwork 파트너 통합</a>을 참고하세요.<br/>" +
                        "추가 도움이 필요하면 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360052605611'>모델 구성 FAQ</a>를 확인하세요.<br/><br/><strong>팁:</strong>" +
                        "<ul>" +
                        "<li>SKAdNetwork는 캠페인 결과에 관한 다양한 데이터를 제공하지 않으므로, 최적화하려는 주요 데이터 유형(예: 수익 또는 참여)에 따라 모델을 선택해야 합니다.</li>" +
                        "<li>전환 이벤트, 참여 또는 퍼널 모델의 경우 측정할 이벤트 그룹을 정의해야 하며, 이 이벤트들은 SDK 통합에서 정의되어야 합니다.</li>" +
                        "<li>퍼널 모델의 경우 이벤트가 발생하는 순서대로 이벤트 목록을 정의해야 합니다. 예를 들어, 게임 앱에서는 \"레벨 2 도달\", \"레벨 5 도달\", \"레벨 10 도달\" 등이 있습니다.</li>" +
                        "</ul><br />",
                    "SKAN_PROBABILISTIC": "iOS 14 이상 캠페인을 진행할 때, 디바이스 식별자가 없을 경우 설치 귀속을 결정하는 두 가지 방법이 있습니다: 권장되는 SKAdNetwork 방식과 확률적 귀속 방식입니다.<br/><br/>" +
                        "확률적 귀속에서는 Singular의 트래킹 URL을 사용해 IP 주소, 디바이스 모델 등 기본 정보를 수집합니다. 하지만 iOS 14.5부터는 개인정보 보호 이슈로 확률적 귀속 방식이 특정 시나리오에 한정되어 사용됩니다. <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360047706852#I_am_an_integrated_partner_supporting_mobile_web_inventory._What_do_I_have_to_prepare_for'>iOS 14 기기에서 확률적 귀속 사용법 자세히 보기</a>.<br/><br/>" +
                        "<strong>팁:</strong>" +
                        "<ul>" +
                        "<li>확률적 귀속을 지원하는 파트너는 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360018879491#smtype'>소스 미디어 타입</a>(_smtype) 트래킹 링크 파라미터를 사용할 수 있습니다. 이 파라미터로 Singular는 해당 터치포인트가 확률적 귀속 대상임을 인지합니다.</li>" +
                        "<li>이 파트너와 작업한다면, 새 요구사항을 준수하는지 확인하거나 Singular의 <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360047706852#I_am_an_integrated_partner_supporting_mobile_web_inventory._What_do_I_have_to_prepare_for'>파트너용 문서</a>를 참고하도록 안내하세요.</li>" +
                        "<li>확률적 캠페인 데이터를 실행하면, 해당 데이터는 정규 보고서 페이지( SKAdNetwork 보고서 페이지가 아님)에서 확인할 수 있습니다.</li>" +
                        "</ul><br/>" +
                        "<strong>궁금한 점이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360002290752-Probabilistic-Attribution-FAQ'>확률적 귀속 FAQ</a>를 참고하세요.",
                    "SKAN_REPORTING": "앱에서 SKAdNetwork 설정, 전환 모델 구성, 그리고 데이터 수집을 위한 충분한 시간이 지난 후, 결과 분석을 시작할 수 있습니다. Singular는 SKAdNetwork를 위한 두 가지 새로운 보고서를 제공합니다:" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li><strong>SKAdNetwork 원시 데이터:</strong> SKAdNetwork 포스트백에서 받은 설치 원시 데이터를(디코딩 전) 분석합니다.</li>" +
                        "<li><strong>SKAdNetwork 보고서:</strong> 광고 네트워크 비용, 노출 통계, CPI 계산을 결합한 SKAdNetwork 데이터를 확인합니다.</li>" +
                        "</ol><br/>" +
                        "<strong>기억할 몇 가지 팁:</strong>" +
                        "<ul>" +
                        "<li>사용자가 앱을 설치한 후 Apple이 설치 데이터를 보내는 데 24~72시간이 걸립니다 (SKAdNetwork 포스트백). 캠페인 시작 후 데이터를 보려면 시간이 필요합니다.</li>" +
                        "<li><strong>Twitter와 Google</strong>은 실제 포스트백을 전달하지 않고 특별 API를 통해 SKAdNetwork 데이터를 Singular에 제공합니다. 따라서 로그 내보내기에서 이 네트워크의 포스트백 수준 데이터를 다운로드할 수 없습니다.</li>" +
                        "<li><strong>Apple Search Ads는 SKAdNetwork를 사용하지 않습니다.</strong> 별도의 캠페인 측정 메커니즘을 가지고 있으며, <strong>ASA 캠페인 데이터는 일반 보고서에서 확인할 수 있습니다</strong> (iOS 14.5 이상 기기 포함).</li>" +
                        "<li>SKAdNetwork 프레임워크는 웹-앱 설치나 확률적 귀속 기반 설치(예: 크로스 프로모션)를 지원하지 않습니다.</li>" +
                        "</ul><br/>" +
                        "<strong>궁금한 점이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/4408232000795'>SKAdNetwork 보고서 FAQ</a>",
                    "ADMON_INTRO": "Singular는 광고 수익화 관련 두 가지 보고 방식을 제공합니다: 광고 수익화 분석(Ad Monetization Analytics)과 광고 수익 귀속(Ad Revenue Attribution).<br/><br/>" +
                        "<strong>광고 수익화 분석:</strong><br/>" +
                        "광고 요청 충족 수, 입찰 요청/응답, 집계된 광고 수익 등 광고 수익화 성과를 분석합니다. Singular는 광고 수익화 소스로부터 집계된 지표를 직접 수집합니다. “Ad Monetization”이라는 이름이 붙은 데이터 커넥터를 찾아보세요.<br/><br/>" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/360022067552'>광고 수익화 FAQ</a>에서 자세히 알아보세요.<br/><br/>" +
                        "<strong>광고 수익 어트리뷰션:</strong><br/>" +
                        "SDK 광고 수익 이벤트와 UA 캠페인 데이터를 결합하여 캠페인 비용, 앱 내 수익, 광고 수익을 한 줄로 통합해 광고 ROI를 완전하게 파악할 수 있습니다.<br/><br/>" +
                        "광고 수익 어트리뷰션은 일반적으로 매체 플랫폼에서 제공하는 노출 수준 광고 수익 데이터를 기반으로 합니다. Singular는 광고 수익 어트리뷰션 데이터를 얻기 위한 다양한 솔루션을 지원합니다.<br/>" +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href='https://support.singular.net/hc/ko/articles/4418187811611-Onboarding-Guide-for-Ad-Revenue-Attribution'>광고 수익 어트리뷰션 온보딩 가이드</a>를 참고하세요.",
                    "ADMON_ANALYZE": "Singular의 광고 수익화 분석을 통해 여러 네트워크에서 집계된 광고 수익을 추적할 수 있습니다. Singular는 매일 광고 수익 데이터를 직접 수집합니다.<br/><br/>" +
                        "관련 광고 수익화 데이터 커넥터(이름에 \"Ad Monetization\"이 포함된)를 모두 추가하는 것부터 시작하세요.<br/><br/>" +
                        "맞춤형 차원, 대시보드 등을 설정하여 보고 기능을 최대한 활용하세요.<br/><br/>" +
                        "<strong>궁금한 점이 있나요?</strong> <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360022067552\">광고 수익화 FAQ</a>를 참고하세요.",
                    "ADMON_SETUP_REVENUE": "매체 플랫폼에서 광고 수익 귀속 데이터를 받으려면 Singular SDK 구현에 코드 스니펫을 추가하세요. 이 방식으로 Singular는 광고 수익 데이터를 다른 SDK 이벤트처럼 수집할 수 있습니다.<br/><br/>" +
                        "<strong>몇 가지 팁:</strong><br/>" +
                        "<ul>" +
                        "<li>보고서와 피벗에서 코호트 지표로 광고 수익 데이터를 볼 수 있습니다.</li>" +
                        "<li>데이터는 매시간 업데이트됩니다.</li>" +
                        "<li>사용자 수준 데이터는 로그 내보내기에서 확인할 수 있습니다.</li>" +
                        "<li>추가 코드 스니펫을 추가한 후 SKAN 통합 수익 모델(광고 수익 이벤트 포함)을 설정하세요.</li>" +
                        "<li>앱별로 서로 다른 매체 플랫폼을 설정할 수 있습니다.</li>" +
                        "</ul>" +
                        "<strong>이 기능 활성화를 위해 Singular 담당자와 상담하세요.</strong> 광고 수익 이벤트 전송에 관한 SDK 문서도 참고하세요: " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360038723351#Adding_Ad_Revenue_Attribution_Support\">iOS</a>, " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360038645131#Adding_Ad_Revenue_Attribution_Support\">Android</a>, " +
                        "<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360038355151#Adding_Ad_Revenue_Attribution_Support\">Unity</a>. " +
                        "실제 적용 전에 SDK 콘솔에서 광고 수익 이벤트를 테스트하세요.<br/><br/>" +
                        "광고 수익 SDK 설정이 어려운 경우, Singular 담당자와 상담하여 다른 데이터 수집 및 계산 방안을 알아보세요.",
                    "ADMON_EXPORT": "광고 수익화 분석(Ad Monetization Analytics)과 광고 수익 귀속(Ad Revenue Attribution) 데이터 모두 다양한 옵션으로 내부 BI 테이블에 내보낼 수 있습니다:<br/>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li style=\"margin: 10px 0;\"><strong>API 통합</strong>은 광고 수익화 분석과 광고 수익 ROI 모두에 제공됩니다." +
                        "<ul style=\"padding-top: 5px\">" +
                        "<li>광고 수익화 API의 모든 세부 사항은 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360045674511\">도움말 센터</a>에서 확인할 수 있습니다.</li>" +
                        "<li>광고 수익 ROI 통계(UA 소스와 결합된 데이터)를 보려면 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360045245692?#h_a89bb16a-6214-448f-b3ab-4443b20cc571\">코호트 메트릭스 엔드포인트</a>에서 데이터를 가져와야 합니다.</li>" +
                        "</ul></li>" +
                        "<li style=\"margin: 10px 0;\"><strong>데이터 목적지(Data Destinations)</strong> — Singular는 선호하는 데이터 웨어하우스에 자동으로 데이터를 푸시합니다. " +
                        "수익화 소스에서 가져온 광고 수익화 지표를 푸시하려면 광고 수익화 스키마를 설정하세요. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360039511492#ad_monetization_data_schema\">Admon Analytics 스키마</a>를 참고하세요.</li>" +
                        "<li style=\"margin: 10px 0;\"><strong>BI 포스트백</strong>은 SDK 광고 수익 이벤트에 사용할 수 있습니다. <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360038040791\">BI 포스트백 구성</a>에 대해 더 알아보세요. 몇 가지 팁:<br/>" +
                        "<ul style=\"padding-top: 5px\">" +
                        "<li>SDK 이벤트 목록에는 __IAP__와 __REVENUE__ 이벤트가 포함됩니다.</li>" +
                        "<li>__IAP__는 별도의 커스텀 이름이 지정되지 않은 모든 인앱 구매 이벤트입니다.</li>" +
                        "<li>__REVENUE__에는 모든 인앱 구매 이벤트 및 광고 수익 이벤트를 포함한 기타 커스텀 수익 이벤트가 포함됩니다.</li>" +
                        "</ul></li>" +
                        "</ol>",
                    "ADMON_EXPORT": "광고 수익 분석과 광고 수익 기여 데이터 모두 다양한 옵션으로 내부 BI 테이블에 내보낼 수 있습니다:<br/>" +
                        "<ol style=\"text-align: left;padding: 10px 0 0 20px\">" +
                        "<li style=\"margin: 10px 0;\"><strong>API 통합</strong>은 광고 수익 분석과 광고 수익 ROI 모두에 사용할 수 있습니다." +
                        "<ul style=\"padding-top: 5px\">" +
                        "<li>광고 수익 API에 대한 모든 세부사항은 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360045674511\">헬프 센터</a>에서 확인할 수 있습니다.</li>" +
                        "<li>광고 수익 ROI 통계(UA 소스와 결합된)를 확인하려면 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360045245692?#h_a89bb16a-6214-448f-b3ab-4443b20cc571\">코호트 메트릭</a> 엔드포인트에서 데이터를 가져와야 합니다.</li>" +
                        "</ul></li>" +
                        "<li style=\"margin: 10px 0;\"><strong>데이터 목적지</strong> - Singular는 데이터 목적지를 통해 선호하는 데이터 웨어하우스로 자동으로 데이터를 전송합니다. " +
                        "광고 수익 소스에서 가져온 광고 수익 지표를 전송하려면 광고 수익 분석 스키마를 설정하세요. 자세한 내용은 <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360039511492#ad_monetization_data_schema\">광고 수익 분석 스키마</a>를 참고하세요.</li>" +
                        "<li style=\"margin: 10px 0;\"><strong>BI 포스트백</strong>은 SDK 광고 수익 이벤트에 사용할 수 있습니다. <a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://support.singular.net/hc/ko/articles/360038040791\">BI 포스트백 설정</a>에 대해 자세히 알아보세요. 몇 가지 팁:<br/>" +
                        "<ul style=\"padding-top: 5px\">" +
                        "<li>SDK 이벤트 목록에는 __IAP__와 __REVENUE__ 이벤트가 포함됩니다.</li>" +
                        "<li>__IAP__는 사용자 지정 이름이 지정되지 않은 모든 인앱 구매 이벤트입니다.</li>" +
                        "<li>__REVENUE__는 모든 인앱 구매 이벤트 및 광고 수익 이벤트를 포함한 기타 모든 사용자 지정 수익 이벤트를 포함합니다.</li>" +
                        "</ul></li>" +
                        "</ol>",
                    "GENERAL_AUDIT": "전체 프로세스에 대해 감사 보고서를 실행하여 실수가 있었는지 확인하세요. " +
                        "보고서는 누락된 단계가 있는지 검토하고 최선의 방법에 대한 팁도 제공합니다. " +
                        "이 보고서는 일반 사용자나 관리자 사용자 모두 사용할 수 있습니다.",
                    "SDK_AUDIT": "SDK 통합 감사를 통해 SDK 및 S2S 통합에서 발생할 수 있는 오류나 버그를 찾아낼 수 있습니다. " +
                        "Singular는 최근 3일간 수신된 이벤트를 검토하여 잠재적인 문제를 잡아냅니다. " +
                        "개발자는 이 보고서를 테스트 콘솔과 함께 사용하여 기본 설정을 제대로 완료했는지 확인할 수 있습니다."
                },
                "BUTTON": {
                    "APPS": "앱 추가",
                    "SDK_CONSOLE_BASIC_EVENTS": "SDK 콘솔로 이동",
                    "GET_STARTED_ADWORDS": "파트너 설정으로 이동",
                    "SET_UP_GOOGLE": "데이터 커넥터 추가",
                    "SET_UP_FACEBOOK": "데이터 커넥터 추가",
                    "SET_UP_APPLE_SEARCH_ADS": "데이터 커넥터 추가",
                    "DATA_CONNECTORS": "데이터 커넥터 추가",
                    "RUN_REPORT": "리포트 실행",
                    "VISUALIZE_CAMPAIGNS": "대시보드 생성",
                    "COHORTED_EVENTS": "이벤트 설정",
                    "PARTNER_CONFIGURATION": "파트너 구성",
                    "CUSTOM_DIMENSIONS": "커스텀 차원 추가",
                    "SKAN_CONVERSION_MODEL": "전환 모델 추가",
                    "SKAN_REPORTING": "SKAdNetwork 리포트 실행",
                    "BI_POSTBACKS": "BI 포스트백 추가",
                    "ETL": "데이터 목적지 추가",
                    "TEST_LINKS": "내보내기 로그로 이동",
                    "MANAGE_LINKS": "링크 생성",
                    "CUSTOM_SOURCES_LINKS": "링크 생성",
                    "DEEP_LINKING": "링크 생성",
                    "REPORTING_API": "API 키 받기",
                    "SKAN_PROBABILISTIC": "링크 추가",
                    "REPORTS_AND_PIVOTS": "리포트 실행",
                    "GENERAL_AUDIT": "대시보드 설정 검수하기",
                    "SDK_AUDIT": "SDK 연동 검수하기",
                    "ADMON_INTRO": "데이터 커넥터 추가",
                    "ADMON_SETUP_REVENUE": "리포트 실행",
                    "SDK_CONSOLE_TESTING": "테스팅 콘솔로 이동",
                    "EXPORT_DATA": "목적지 추가",
                    "MARK_AS_DONE": "완료로 표시",
                    "SDK_INTEGRATION": "SDK 계획으로 이동",
                    "SHOW_KEYS": "키 표시",
                    "HIDE_KEYS": "키 숨기기"
                },
                "POPUP": {
                    "MARK_AS_DONE": {
                        "TEXT": "이 단계를 완료로 표시하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
                        "ACCEPT_TEXT": "완료로 표시"
                    }
                },
                "TOOLTIP": {
                    "AVAILABLE_AFTER_FIRST_STEP": "'온보딩 계획 세우기'를 완료하면 이 단계들을 사용할 수 있습니다."
                },
                "BADGE": {
                    "ADDED": "${count}개 추가됨"
                }
            },
            "SDK_CONFIGURATION": {
                "WELCOME_TEXT": "Singular에 오신 것을 환영합니다!",
                "SUMMARY_DONE_TITLE": "여기 귀하의 온보딩 계획입니다:",
                "EDIT_PLAN_BUTTON": "계획 수정하기",
                "START_WIZARD_BUTTON": "시작하기",
                "SKIP_WIZARD_BUTTON": "마법사 건너뛰기",
                "NEXT_BUTTON": "다음",
                "CONTINUE_BUTTON": "온보딩 계속하기",
                "DISABLED_QUESTION_LABEL": "해당 없음",
                "SKIP_POPUP": {
                    "BODY_TEXT": "정말로 마법사를 건너뛰시겠습니까? 건너뛰면 일반적인 추천만 제공되며, 설정 검증을 정확하게 도와드릴 수 없습니다.\n\n취소를 누르면 마법사로 돌아갑니다.",
                    "ACCEPT_BUTTON": "예, 건너뛰기"
                },
                "TOP_TEXT_1": "온보딩을 시작하려면 마케팅 목표에 대해 더 알려주세요.<br/>답변에 따라 추천을 드리며, 답변이 없으면 권장 기본값을 보여드립니다.",
                "TOP_TEXT_2": "언제든 돌아와서 변경할 수 있습니다!",
                "PLATFORMS_STEP": {
                    "TITLE": "플랫폼",
                    "PLATFORMS_QUESTION": {
                        "TEXT": "어떤 플랫폼에서 마케팅을 진행하시나요?",
                        "HELP": "향후 홍보할 계획인 플랫폼을 선택하세요"
                    },
                    "PLATFORM_LABEL_ANDROID": "안드로이드",
                    "PLATFORM_LABEL_IOS": "iOS",
                    "PLATFORM_LABEL_PC": "PC/콘솔",
                    "PLATFORM_LABEL_WEB": "웹",
                    "SELECT_PLATFORM": "• 최소 하나의 플랫폼을 선택하세요",
                    "TOGGLE_OPTIONS": {
                        "YES": "예",
                        "NO": "아니오"
                    },
                    "DISABLED_PLATFORM_TOOLTIP": "이 플랫폼은 귀하의 플랜에서 사용할 수 없습니다"
                },
                "OTHER_SDKS_STEP_TITLE": "기타 SDK",
                "PRIVACY_STEP_TITLE": "사용자 개인정보 및 동의",
                "CAMPAIGNS_CONFIG_STEP_TITLE": "네트워크 및 어트리뷰션 유형",
                "MONETIZATION_STEP_TITLE": "수익화 이벤트",
                "PLATFORMS_STEP_WIZARD_LABEL": "플랫폼",
                "OTHER_SDKS_STEP_WIZARD_LABEL": "기타 SDK",
                "PRIVACY_STEP_WIZARD_LABEL": "사용자 개인정보 및 동의",
                "CAMPAIGNS_CONFIG_STEP_WIZARD_LABEL": "네트워크 및 어트리뷰션 유형",
                "MONETIZATION_STEP_WIZARD_LABEL": "수익화 이벤트",
                "CATEGORIES": {
                    "PLATFORM_CATEGORY": "플랫폼",
                    "OTHER_SDK_CATEGORY": "기타 SDK",
                    "USER_PRIVACY_CATEGORY": "사용자 개인정보 및 동의",
                    "CAMPAIGN_TYPES_CATEGORY": "다음 캠페인 유형을 운영하실 예정인가요:",
                    "SINGULAR_TRACKING_LINKS_CATEGORY": "Singular 트래킹 링크를 다음 용도로 사용하시나요:",
                    "SINGULAR_FEATURES_USAGE_CATEGORY": "다음 기능을 사용하시나요:",
                    "NETWORK_SPECIFIC_CATEGORY": "다음 네트워크로 캠페인을 운영하실 예정인가요",
                    "APP_MONETIZATION_CATEGORY": "앱 수익화 방법은?",
                    "APP_MONETIZATION_CATEGORY_TOOLTIP": "앱에서 사용할 수익화 모델을 알려주세요."
                },
                "QUESTIONS": {
                    "YOUR_PLATFORMS": "귀하의 플랫폼",
                    "IS_USING_OTHER_MMP": "현재 다른 MMP를 사용하고 계신가요?",
                    "IS_USING_OTHER_MMP_TOOLTIP": "현재 다른 MMP를 사용하고 계신가요?",
                    "IMPORT_DATA_FROM_CURRENT_MMP": "이전 MMP의 과거 데이터를 가져오고 싶습니다",
                    "IS_USING_FIREBASE_SDK": "현재 Firebase SDK를 사용하고 계신가요?",
                    "IS_USING_META_SDK": "현재 Facebook/Meta Ads SDK를 사용하고 계신가요?",
                    "IS_TARGETING_CHILDREN": "귀하의 앱이 아동용인가요? 혹은 추가적인 개인정보 보호 요구사항이 있나요?",
                    "IS_TARGETING_CHILDREN_TOOLTIP": "Singular는 사용자 수준 및 PII 데이터 제한을 관리하면서 어트리뷰션 기능을 유지할 수 있는 추가 SDK 및 기능을 제공합니다.",
                    "IS_RUNNING_SKAN_CAMPAIGNS": "SKAN 캠페인 진행 여부",
                    "IS_SHOWING_ATT_PROMPT": "iOS - ATT 알림을 표시할 예정인가요?",
                    "IS_SHOWING_ATT_PROMPT_TOOLTIP": "앱 추적 투명성(ATT)은 마케터가 추적 전에 사용자 동의를 얻도록 요구하는 Apple의 개인정보 보호 정책 변경입니다.",
                    "IS_USING_DEEP_LINKING_TRACKING_LINKS": "딥링킹 또는 지연 딥링킹을 사용하시나요?",
                    "IS_USING_DEEP_LINKING_TRACKING_LINKS_TOOLTIP": "딥링킹 URL은 사용자가 앱을 열도록 하는 것뿐 아니라, 앱 내 특정 페이지나 경험(예: 전자상거래 앱의 특정 상품)으로 직접 연결합니다.",
                    "IS_USING_BI_POSTBACKS": "BI 포스트백 사용 여부",
                    "IS_RUNNING_RE_TARGETING": "재참여 캠페인 운영 여부",
                    "IS_RUNNING_RE_TARGETING_TOOLTIP": "재참여 캠페인은 이미 앱을 설치한 사용자 중 특정 비활성 기간이 지난 사용자를 추적하는 데 도움을 줍니다.",
                    "IS_USING_TRACKING_LINKS_FOR_EMAIL_CAMPAIGNS": "이메일 캠페인용 트래킹 링크 사용 여부",
                    "IS_USING_TRACKING_LINKS_FOR_SMS_CAMPAIGNS": "SMS 캠페인용 트래킹 링크 사용 여부",
                    "IS_RUNNING_INFLUENCER_CAMPAIGNS": "인플루언서 캠페인 운영 여부",
                    "IS_RUNNING_INFLUENCER_CAMPAIGNS_TOOLTIP": "인플루언서가 사용할 트래킹 링크를 생성할 예정인가요?",
                    "IS_RUNNING_APPLE_SEARCH_ADS_CAMPAIGNS": "Apple Search Ads 캠페인 운영 여부",
                    "IS_RUNNING_FACEBOOK_CAMPAIGNS": "Meta Ads/Facebook/Instagram 캠페인 운영 여부",
                    "IS_RUNNING_GOOGLE_ADS_CAMPAIGNS": "Google Ads 캠페인 운영 여부",
                    "IS_RUNNING_NETWORKS_WITH_TRACKING_LINKS": "트래킹 링크가 있는 네트워크 운영 여부",
                    "IS_RUNNING_NETWORKS_WITH_TRACKING_LINKS_TOOLTIP": "트래킹 링크가 있는 네트워크는 제휴사부터 Unity, Moloco 같은 SDK 네트워크까지 다양합니다.",
                    "IS_APP_MONETIZING_SUBSCRIPTION_BASED": "구독 기반 수익화 여부",
                    "IS_APP_MONETIZING_IN_APP_PURCHASE_BASED": "인앱 구매 기반 수익화 여부",
                    "IS_APP_MONETIZING_IN_APP_PURCHASE_BASED_TOOLTIP": "인앱 구매는 SDK에서 수익 이벤트로 설정되어야 Singular가 ROI를 계산할 수 있습니다.",
                    "IS_AD_MONETIZATION_BASED": "광고 수익화 여부",
                    "SELECT_MEDIATION_PLATFORM": "어떤 중개 플랫폼을 사용하고 계신가요?",
                    "SELECT_MEDIATION_PLATFORM_TOOLTIP": "앱 내에서 광고를 보여주나요?"
                }
            },
            "SIDEBAR_PROGRESS_BAR": {
                "SDK_CONFIGURATION": "온보딩 계획하기",
                "NEXT_STEP": "다음 단계",
                "APPS": "앱 추가",
                "SDK_INTEGRATED": "SDK 통합하기",
                "SDK_CONSOLE_TESTING": "SDK 테스트",
                "WEB_SDK_INTEGRATION": "웹 어트리뷰션",
                "COHORTED_EVENTS": "이벤트 추가",
                "PARTNER_CONFIGURATION": "파트너 설정",
                "DATA_CONNECTORS": "데이터 커넥터 추가",
                "SKAN_CONVERSION_MODEL": "SKAN 전환 모델 설정",
                "MANAGE_LINKS": "트래킹 링크 만들기",
                "SET_UP_GOOGLE": "Google Ads 설정",
                "SET_UP_FACEBOOK": "Meta Ads / Instagram 설정",
                "SET_UP_APPLE_SEARCH_ADS": "Apple Search Ads 설정"
            },
            "ACCOUNT_PLAN": {
                "HEADER": "계정 플랜",
                "PLAN_DETAILS": "플랜 세부정보",
                "INSTALLS": "전환",
                "FREE_INSTALLS": "무료 전환",
                "PAID_INSTALLS": "전환",
                "AD_SPEND": "광고 지출",
                "TIMEZONE": "시간대",
                "CURRENCY": "통화",
                "START_DATE": "시작 날짜",
                "EXPIRATION_DATE": "만료일",
                "UNLIMITED": "∞ 무제한",
                "TIER": {
                    "TITLE": "플랜",
                    "FREE": "무료",
                    "FREE_STARTER": "스타터",
                    "STANDARD_UNIFIED": "성장형",
                    "TRIAL": "성장형 체험판",
                    "ENTERPRISE": "엔터프라이즈"
                },
                "BLOCKED_ORF_ERROR_MSG": "<b>한도에 도달했습니다!</b> 계속 사용하려면 플랜을 업그레이드하세요.",
                "PLAN_PRICE": "플랜 가격",
                "YEARLY": "연간",
                "INSTALL_CAP": "전환 한도",
                "INSTALL_CAP_FREE": "처음 15,000건 전환은 무료입니다!",
                "INSTALL_CAP_FREE_INFO": "언제든지 추가 구매하세요.",
                "AD_SPEND_CAP": "광고 지출 한도",
                "NO_PLAN": "활성 플랜이 없습니다",
                "BE_IN_TOUCH": "감사합니다! 곧 연락드리겠습니다.",
                "ADD_ONS": "애드온 (${value}/${total})",
                "ADVANCED_COLLECT": "고급 수집 및 인사이트",
                "BADGE": {
                    "YOUR_PLAN": "현재 플랜"
                },
                "PERCENT_USED": "${percent}% 사용됨",
                "TOTAL_CONVERSIONS": "${percent}% 총 전환 수",
                "PRICING_CARDS": {
                    "CONTAINER": {
                        "HEADER": "플랜 업그레이드"
                    },
                    "TITLE": {
                        "FREE": "스타터",
                        "STANDARD_UNIFIED": "성장형",
                        "ENTERPRISE": "엔터프라이즈"
                    },
                    "DESCRIPTION": {
                        "FREE": "이 플랜은 핵심 기능과 선불 전환의 유연성을 제공합니다.",
                        "STANDARD_UNIFIED": "기술 온보딩 지원 및 고객 성공 매니저가 포함된 플랜입니다.",
                        "ENTERPRISE": "가장 포괄적인 플랜으로 지속적인 성장을 이끌어보세요."
                    },
                    "CTA": {
                        "FREE": "지금 결제하기",
                        "STANDARD_UNIFIED": "세일즈팀에 문의하기",
                        "ENTERPRISE": "세일즈팀에 문의하기"
                    },
                    "PRICING": {
                        "FREE": "선불 전환 추가",
                        "STANDARD_UNIFIED": "전환당 $0.05",
                        "ENTERPRISE": "맞춤형 플랜 받기"
                    },
                    "BODY": {
                        "FREE": "<ul style='padding-left: 16px'><li>결제 및 고객 지원 제공</li><li>최고 수준의 모바일 어트리뷰션</li><li>우수한 ROI 분석 및 부정행위 방지</li><li>딥링크 및 커스텀 링크</li><li>SKAdNetwork 어트리뷰션</li><li>강력한 API</li><li>SKAdNetwork 코호트 예측</li><li>대시보드 사용자 정의</li><li>크리에이티브 리포팅</li></ul>",
                        "STANDARD_UNIFIED": "<b>스타터 플랜 포함, 추가 기능:</b><br><ul style='padding-left: 22px'><li>솔루션 엔지니어의 1:1 온보딩</li><li>고객 지원</li><li>제한된 사용자 설정</li></ul><br><b>추가 기능:</b><br><ul style='padding-left: 22px'><li>코드 없는 ETL 및 데이터 전송</li><li>광고 수익 어트리뷰션 및 분석</li><li>웹 어트리뷰션</li><li>웹 CAPI 통합</li><li>PC 및 콘솔 지원</li></ul>",
                        "ENTERPRISE": "<b>성장형 플랜 포함, 추가 기능:</b><br><ul style='padding-left: 22px'><li>전담 고객 성공 매니저</li><li>엔터프라이즈급 SLA</li><li>디바이스 간 어트리뷰션</li><li>365일 코호트 분석</li><li>오디언스 관리</li><li>고급 권한 관리</li><li>싱글 사인온 (SSO)</li><li>프라이빗 클라우드 (선택사항)</li></ul>"
                    },
                },
                "PACING_CARD": {
                    "TITLES": {
                        "CONVERSIONS": "전환 진행률",
                        "AD_SPEND": "광고 지출 진행률"
                    },
                    "DESCRIPTION": {
                        "CONVERSIONS": "추적된 전환 수",
                        "AD_SPEND": "추적된 광고 지출"
                    },
                    "INFORMATION": {
                        "NO_USAGE": "<b>축하합니다! 플랜에 ${maxValue}건의 무료 전환이 포함되어 있습니다!</b> 계속해서 Singular를 사용할 수 있습니다.",
                        "USAGE": "<b>플랜에 ${usageLeft}건의 ${valueType}이 남아 있습니다!</b> 언제든지 업그레이드하여 Singular를 계속 사용하세요.",
                        "MAXED_CAP": "<b>플랜 한도를 ${usageLeft} ${valueType} ${capType} 초과했습니다!</b> 계속 사용하려면 플랜을 업그레이드하세요.",
                        "DATE_EXPIRED": "<b>플랜 만료까지 ${expiresInDays}일 남았습니다!</b> Singular 사용을 계속하려면 업그레이드하세요.",
                        "EXPIRED": "<b>플랜이 ${expiresInDays}일 전에 만료되었습니다!</b> 계속 사용하려면 업그레이드하세요.",
                    },
                    "CAP_TYPE": {
                        "AD_SPEND": "광고 지출",
                    },
                    "VALUE_TYPE": {
                        "CONVERSIONS": "전환",
                        "AD_SPEND": "USD",
                    }
                },
                "BUTTONS": {
                    "PLAN_DETAILS": "모든 플랜 세부정보 보기",
                    "BUY_CONVERSIONS": "전환 구매",
                    "SPEAK_TO_SALES":  "세일즈팀에 문의하기",
                    "LEARN_MORE": "자세히 알아보기",
                },
                "TOOLTIPS": {
                    "PACING_CARD": "추적된 전환에는 설치, 재참여 또는 웹 세션이 포함됩니다. iOS의 경우 SKAN 설치 수와 추적기 설치 수 중 더 큰 값을 사용합니다.",
                    "PLAN_DETAILS_START_DATE": "가입일 또는 가장 최근 결제일 중 더 이른 날짜입니다 (해당되는 경우).",
                    "PROGRESS_BAR_MOBILE": "${percentage}% 모바일 전환: ${value}",
                    "PROGRESS_BAR_WEB": "${percentage}% 웹 전환: ${value}",
                    "PROGRESS_BAR_PC_CONSOLE": "${percentage}% PC/콘솔 전환: ${value}"
                },
                "CONVERSIONS": {
                    "MOBILE": "<b>모바일</b> (${value})",
                    "WEB": "<b>웹</b> (${value})",
                    "PC_CONSOLE": "<b>PC/콘솔</b> (${value})"
                },
                "FEATURE_STATUS": {
                    "CONTRACTED": "계약됨",
                    "TRIAL": "체험판",
                    "AVAILABLE": "사용 가능",
                }
            }
        },
        "SHARE_URL_DISCLAIMER2": "보고서 표시되는 데이터를 제한하고 책임을 가지고 공유하여 주세요.",
        "FORMATS": {
            "REPORTS_CHART_MONTH_PERIOD": "YYYY년 MMMM",
            "REPORTS_CHART_DAY_PERIOD": "LL"
        },
    },
    "Pending integration": "연동 준비중",
    "Tracker Clicks": "트래커 클릭",
    "Please verify login credentials": "로그인 정보를 확인해 주세요",
    "You have invalid accounts, please remove them.": "유효하지 않은 계정이 있으니, 삭제하여 주시기 바랍니다",
    "Tracker Publisher ID": "트래커 퍼블리셔 ID",
    "Tracker Name": "트래커 이름",
    "Alerts": "알림",
    "Revenue": "매출",
    "Source": "소스",
    "App + OS Report": "앱 + OS 리포트",
    "Account Name": "계정 이름",
    "exclude": "제외",
    "Sub Campaign": "서브 캠페인",
    "Cost Forecast (%)": "비용 예측 (%)",
    "Automation": "자동화",
    "Tracker Installs": "트래커 설치",
    "Clicks": "클릭",
    "Cost per Event (CPE)": "이벤트당 비용",
    "Please verify authorization": "인증서를 확인해 주세요",
    "Week": "주",
    "Select a dimension": "디멘션 선택",
    "Original Cost": "본래의 비용",
    "Please add MCC Customer ID": "MCC 고객 ID를 추가해 주세요",
    "Please verify authorization & the MCC Customer ID": "인증서와 MCC 고객 ID를 확인해 주세요",
    "Total Budget": "총 예산",
    "All Time": "모든 기간",
    "Sub Ad Network": "서브 애드네트워크",
    "Undergoing Verification": "확인 중",
    "Event Conversion Rate (ECVR)": "이벤트 전환율",
    "Full Members": "정회원",
    "Data Sources": "데이터 소스",
    "Cost": "비용",
    "Network Report": "네트워크 리포트",
    "Ad Network Report": "AD 네트워크 리포트",
    "Goal Complete (%)": "목표완료(%)",
    "Network Clicks": "네트워크 클릭",
    "Please add Account IDs": "계정 ID를 추가해 주세요",
    "Day": "일",
    "You haven't defined any goals yet": "아직 목표를 정의하지 않았습니다.",
    "Status": "상태",
    "Account ID": "계정 ID",
    "Agency": "대행사",
    "Login successful": "로그인 성공",
    "Keyword": "키워드",
    "Installs": "인스톨",
    "Country": "국가",
    "Est. Conversions": "추정 전환",
    "Retargeting": "리타게팅",
    "Campaign URL": "캠페인 URL",
    "Click Type": "클릭 유형",
    "Totals": "합계",
    "Data source is disabled": "데이터 소스 확인 불가",
    "OS Report": "OS 리포트",
    "Custom Events": "커스텀 이벤트",
    "Creative": "크리에이티브",
    "Cost Forecast": "비용 예측",
    "include": "포함",
    "d": "일",
    "Campaign": "캠페인",
    "Platform": "플랫폼",
    "App": "앱",
    "Original Currency": "본래의 화폐단위",
    "Month": "월",
    "Analytics": "분석",
    "Network Installs": "네트워크 설치",
    "API": "API",
    "Pending Invitations": "초대 대기중",
    "Cost Goal": "비용 목표",
    "Impressions": "노출",
    "Source configured successfully": "소스가 성공적으로 설정되었습니다.",
    "Size": "크기",
    "Campaign ID": "캠페인 ID",
    "Manage Team": "팀관리",
    "Attribution": "어트리뷰션",
    "New Alert": "새로운 알림",
    "My Dashboards": "내 대시보드",
    "Reports & Insights": "보고서 및 통계",
    "Pivot": "피벗",
    "Unified iOS": "통합 iOS",
    "Creatives": "크리에이티브",
    "Campaign Report": "캠페인 보고서",
    "Cross Device": "크로스 디바이스",
    "Ad Monetization": "광고 수익화",
    "Retention": "리텐션",
    "Goals": "목표",
    "Media Mix Modeling": "미디어 믹스 모델링",
    "Multi-Touch": "다중 터치",
    "Assisted Installs": "멀티 터치",
    "Export Logs": "로그 내보내기",
    "Creative IQ": "크리에이티브 IQ",
    "Creative Gallery": "크리에이티브 갤러리",
    "Creative Explore": "크리에이티브 탐색",
    "SKAdnetwork": "SKAdnetwork",
    "Raw Data": "로우 데이터",
    "Reports": "보고서",
    "Model Configuration": "모델 구성",
    "Benchmarks": "벤치마크",
    "Market Snapshot": "시장 스냅샷",
    "Cost Portfolio": "비용 포트폴리오",
    "Network Optimization": "네트워크 최적화",
    "Audiences": "잠재고객",
    "Segments": "세그먼트",
    "Distributions": "분포",
    "Incrementality Tests": "증분 테스트",
    "Fraud Prevention": "사기 방지",
    "Dashboard": "대시보드",
    "Rejected Report": "거부된 보고서",
    "Suspicious Report": "의심스러운 보고서",
    "Protected Report": "보호된 보고서",
    "Global Settings": "글로벌 설정",
    "Custom Rules": "사용자 지정 규칙",
    "Banners": "배너",
    "Attribution Setup": "어트리뷰션 설정",
    "Manage Links": "링크 관리",
    "Partner Configuration": "파트너 구성",
    "View Links": "링크 보기",
    "Create Link": "링크 만들기",
    "Create Custom Link": "사용자 지정 링크 만들기",
    "Create Web Link": "웹 링크 만들기",
    "Data Integrations": "데이터 통합",
    "Data Connectors": "데이터 커넥터",
    "Data Destinations": "데이터 대상",
    "Data Customization": "데이터 사용자화",
    "Custom Dimensions": "커스텀 디멘션",
    "Governance Schema": "거버넌스 스키마",
    "Governance Codes": "거버넌스 코드",
    "Partner Fees": "파트너 수수료",
    "Static": "정적",
    "Creative Tags": "크리에이티브 태그",
    "CPI Configuration": "CPI 구성",
    "Settings": "설정",
    "Apps": "앱",
    "Data Alerts": "데이터 알림",
    "Events": "이벤트",
    "Usage": "사용량",
    "Developer Tools": "개발자 도구",
    "Reporting API Keys": "리포팅 API 키",
    "Testing Console": "테스트 콘솔",
    "SDK Integration": "SDK 연동",
    "Help Center": "도움말 센터",
    "Product Updates": "제품 업데이트",
    "Admin": "관리자",
    "Invite": "초대",
    "Custom Metrics": "커스텀 지표",
    "Manual Upload": "수동 업로드",
    "Partner Integration": "파트너 연동",
    "Singular Admin": "Singular 관리자",
    "Ad Network Access": "광고 네트워크 액세스",
    "Onboarding Guide": "시작 가이드",
};
languages['ko'] = ko;

module.exports = ko;
